<main id="main" class="main">
  <div class="mainScreen">
    <div style="padding: 2px; background-color: white; height: max-content">
      <!-- Start of White Card -->
      <div
        style="background-color: white; border-radius: 2px; height: max-content"
      >
        <!-- Section Header -->
        <div
          class="header-height"
          style="
            background-color: #142a49;
            color: white;
            display: flex;
            align-items: center;
            border-radius: 3px;
          "
        >
          <label
            class="headingFontSize"
            style="margin-left: 10px; background-color: #142a49"
          >
            {{ mode === "update" ? "Update Supplier" : lang.Supplier }}&nbsp;<i
              class="bi bi-info-circle"
            ></i>
          </label>
        </div>

        <!-- Form Fields -->
        <div
          style="
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
            padding: 15px;
            border-radius: 0 0 6px 6px;
          "
        >
          <!-- Supplier ID -->
          <div style="display: flex; flex-direction: column">
            <label class="fontSize">{{ lang.Supplier_ID }}</label>
            <input
              type="text"
              placeholder="{{ lang.Supplier_ID }}"
              [value]="supplierID"
              disabled
              style="
                width: 180px;
                height: 30px;
                padding: 6px 10px;
                font-size: 14px;
                border: 1px solid #ccc;
                border-radius: 6px;
                outline: none;
                background-color: #e8eaf0;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
              "
            />
          </div>

          <!-- Supplier Name -->
          <div
            style="
              width: 400px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <label class="fontSize">{{ lang.Supplier_Name }}</label>

            <!-- INPUT -->
            <input
              type="text"
              placeholder="{{ lang.Supplier_Name }}"
              [(ngModel)]="supplierName"
              (ngModelChange)="onSupplierInput($event)"
              style="
                width: 180px;
                height: 30px;
                padding: 6px 10px;
                font-size: 14px;
                border: 1px solid #ccc;
                border-radius: 6px;
                outline: none;
                background-color: #e8eaf0;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                text-transform: capitalize;
              "
            />

            <!-- ERROR MESSAGE -->
            <div
              *ngIf="matchedSupplierName"
              style="
                margin-top: 5px;
                color: #ff0000;
                font-size: 11px;
                width: 350px;
                word-wrap: break-word;
                margin-top: -1px;
              "
            >
              <i class="fa fa-info-circle" style="color: #f60505"></i>
              <strong> {{ matchedSupplierName }}</strong> already exists.
            </div>
            <!-- Error msg -->
            <div class="error" *ngIf="errors.supplierName">
              {{ errors.supplierName }}
            </div>
          </div>
        </div>

        <!-- Group Contacts Section (also inside the card) -->
        <!-- *ngIf="supplierName?.length > 3 && !matchedSupplierName" -->

        <div *ngIf="!matchedSupplierName && supplierName?.length > 0">
          <!--  Header -->
          <div
            class="header-height"
            style="
              background: #142a49;
              color: white;
              border-top: 1px solid #ddd;
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: relative;
              border-radius: 3px;
            "
          >
            <h3
              class="headingFontSize"
              style="
                margin-left: 10px;
                background-color: #142a49;
                margin-top: 9px;
              "
            >
              {{ lang.Contact_Information }}&nbsp;<i
                class="bi bi-info-circle"
              ></i>
            </h3>
            <button
              (click)="showContactModal = true"
              style="
                position: absolute;
                right: 3px;
                background-color: white;
                color: #142a49;
                border: 1px solid #707070;
                border-radius: 4px;
                padding: 2.5px 15px;
                font-size: 13px;
                cursor: pointer;
                margin: 3px;
              "
            >
              + {{ lang.Add }}
            </button>
          </div>
          <!-- Showing contact Table -->
          <div
            style="
              max-height: 130px;
              overflow-y: auto;
              border: 1px solid #b9b9b9;
            "
          >
            <table
              style="
                width: 100%;
                border-collapse: collapse;
                font-family: Arial, sans-serif;
                border: 1px solid #b9b9b9;
                font-size: 12px;
              "
            >
              <thead>
                <tr
                  style="background-color: #808285; color: white; height: 29px"
                >
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 16%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    {{ lang.First_Name }}
                  </th>
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 16%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    {{ lang.Last_Name }}
                  </th>
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 20%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    {{ lang.Email }}
                  </th>
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 18%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    {{ lang.Phone_Number }}
                  </th>
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 15%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    Role
                  </th>
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 15%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    {{ lang.Actions }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr
                  *ngFor="let contact of contacts; let i = index"
                  style="
                    background-color: #f6f6f6;
                    height: 29px;
                    font-size: 14px;
                  "
                >
                  <td style="text-align: left; padding: 2px 8px">
                    {{ contact.firstName }}
                  </td>
                  <td style="text-align: left; padding: 2px 8px">
                    {{ contact.lastName }}
                  </td>
                  <td style="text-align: left; padding: 2px 8px">
                    {{ contact.email }}
                  </td>
                  <td style="text-align: left; padding: 2px 8px">
                    {{ formatPhoneNumber(contact.phone) }}
                  </td>
                  <td style="text-align: left; padding: 2px 8px">
                    {{ contact.role }}
                  </td>
                  <td style="text-align: left; padding: 2px 8px">
                    <button
                      (click)="editSupplier(i)"
                      style="
                        background-color: #c87b00;
                        border: none;
                        border-radius: 6px;
                        cursor: pointer;
                        margin-right: 5px;
                        color: white;
                        padding: 2px 8px;
                        font-size: 12px;
                      "
                    >
                      <i class="bi bi-pencil-fill"></i>
                    </button>
                    <button
                      (click)="deleteContact(contact, i)"
                      style="
                        background-color: #6b1004;
                        border: none;
                        border-radius: 6px;
                        cursor: pointer;
                        color: white;
                        padding: 2px 8px;
                        font-size: 12px;
                      "
                    >
                      <i class="bi bi-trash-fill"></i>
                    </button>
                  </td>
                </tr>

                <!-- No data fallback -->
                <tr *ngIf="contacts.length === 0" style="height: 29px">
                  <td colspan="6" style="padding: 4px 8px; color: #333">
                    No Data available!
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- contact form -->

          <!-- Show Popup for add more contacts -->
          <!-- Popup For Add Contact -->
          <!-- Add Contact Popup -->
          <div
            *ngIf="showContactModal"
            class="modal fade show d-block"
            data-bs-backdrop="static"
            id="basicModal1"
            tabindex="-1"
            style="background: rgba(0, 0, 0, 0.5)"
          >
            <div
              style="width: 400px"
              class="modal-dialog modal-dialog-centered"
            >
              <div class="modal-content">
                <!-- Header -->
                <div
                  style="
                    background-color: #142a49;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <h6 style="margin: 6px; background-color: #142a49">
                    Add Contact
                  </h6>
                  <button
                    (click)="onCloseEditPopup()"
                    style="margin: 3px"
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <!-- Body -->
                <div class="modal-body">
                  <form class="onbordingform">
                    <!-- First row -->
                    <div style="display: flex; column-gap: 10px; width: 100%">
                      <!-- First Name -->
                      <div>
                        <label class="fontSize">{{ lang.First_Name }}</label
                        ><br />
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="firstName"
                          placeholder="{{ lang.First_Name }}"
                          [formControl]="contactForm.controls['firstName']"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted &&
                            contactForm.controls['firstName'].errors
                          "
                        >
                          First name is required
                        </div>
                      </div>

                      <!-- Last Name -->
                      <div>
                        <label class="fontSize">{{ lang.Last_Name }}</label
                        ><br />
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="lastName"
                          placeholder="{{ lang.Last_Name }}"
                          [formControl]="contactForm.controls['lastName']"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted && contactForm.controls['lastName'].errors
                          "
                        >
                          Last name is required
                        </div>
                      </div>
                    </div>

                    <!-- Second row -->
                    <div style="display: flex; column-gap: 10px; width: 100%">
                      <!-- Email -->
                      <div>
                        <label class="fontSize">{{ lang.Email }}</label
                        ><br />
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="email"
                          placeholder="{{ lang.Email }}"
                          [formControl]="contactForm.controls['email']"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: lowercase;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted && contactForm.controls['email'].errors
                          "
                        >
                          <span
                            *ngIf="
                              contactForm.controls['email'].errors?.required
                            "
                            >Email is required</span
                          >
                          <span
                            *ngIf="contactForm.controls['email'].errors?.email"
                            >Invalid email format</span
                          >
                        </div>
                      </div>

                      <!-- Phone -->
                      <div>
                        <label class="fontSize">{{ lang.Phone_Number }}</label
                        ><br />
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="phone"
                          (keydown)="
                            allowOnlyNumbersForPhoneNumber($event, phone)
                          "
                          [formControl]="contactForm.controls['phone']"
                          max="10"
                          placeholder="{{ lang.Phone_Number }}"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted && contactForm.controls['phone'].errors
                          "
                        >
                          <span
                            *ngIf="
                              contactForm.controls['phone'].errors?.required
                            "
                          >
                            Phone number is required
                          </span>
                          <span
                            *ngIf="
                              contactForm.controls['phone'].errors?.pattern
                            "
                          >
                            Phone number must be exactly 10 digits
                          </span>
                        </div>
                      </div>
                    </div>

                    <!-- Third row -->
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        /* flex-wrap: wrap; */
                        column-gap: 10px;
                        width: 100%;
                        margin-top: 2px;
                      "
                    >
                      <!-- Role -->
                      <div style="display: flex; flex-direction: column">
                        <label class="fontSize">{{ lang.Roles }}</label>
                        <select
                          [(ngModel)]="role"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="onRoleChange($event)"
                          [formControl]="contactForm.controls['role']"
                          style="
                            width: 178px;
                            height: 30px;
                            line-height: 18px;
                            font-size: 13px;
                            padding: 2px 10px;
                            border: 1px solid #ccc;
                            border-radius: 5px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-sizing: border-box;
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        >
                          <option value="" disabled>Select</option>
                          <option *ngFor="let role of roles" [value]="role">
                            {{ role }}
                          </option>
                        </select>
                        <div
                          class="error"
                          *ngIf="
                            submitted && contactForm.controls['role'].errors
                          "
                        >
                          Role is required
                        </div>
                      </div>

                      <!-- Other Role Input -->
                      <div *ngIf="showOther" style="margin-top: -3px">
                        <label class="fontSize">Other</label><br />
                        <input
                          type="text"
                          [(ngModel)]="contact_other"
                          [ngModelOptions]="{ standalone: true }"
                          placeholder="Enter Role"
                          [formControl]="contactForm.controls['contact_other']"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted &&
                            contactForm.controls['contact_other'].errors
                          "
                        >
                          This field is required
                        </div>
                      </div>
                      <!-- Email Reporting -->
                      <div *ngIf="!showOther" style="margin-top: 15px">
                        <label
                          style="
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                          "
                        >
                          <input
                            type="checkbox"
                            [(ngModel)]="emailReports"
                            [ngModelOptions]="{ standalone: true }"
                            style="
                              margin-right: 8px;
                              width: 16px;
                              height: 16px;
                              cursor: pointer;
                            "
                          />
                          <span class="fontSize">Email Reports</span>
                        </label>
                      </div>
                    </div>
                    <div *ngIf="showOther" style="margin-top: 15px">
                      <label
                        style="
                          display: flex;
                          align-items: center;
                          cursor: pointer;
                        "
                      >
                        <input
                          type="checkbox"
                          [(ngModel)]="emailReports"
                          [ngModelOptions]="{ standalone: true }"
                          style="
                            margin-right: 8px;
                            width: 16px;
                            height: 16px;
                            cursor: pointer;
                          "
                        />
                        <span class="fontSize">Email Reports</span>
                      </label>
                    </div>
                  </form>
                </div>

                <!-- Footer Buttons -->
                <div class="modal-footer">
                  <!-- Cancel Button -->
                  <!-- Cancel-Style Button -->
                  <button
                    class="btn btn-sm fontSize"
                    style="
                      font-size: 13px;
                      padding: 4px 12px;
                      border-radius: 4px;
                      background-color: #ffffff;
                      color: #0b2e67;
                      border: 1px solid #0b2e67;
                      cursor: pointer;
                    "
                    (click)="onCloseEditPopup()"
                  >
                    Cancel
                  </button>

                  <!-- Save Button -->
                  <!-- Save-Style Button -->
                  <button
                    class="btn btn-sm fontSize"
                    style="
                      font-size: 14px;
                      padding: 4px 12px;
                      border-radius: 4px;
                      background-color: #142a49;
                      border: 1px solid #142a49;
                      color: #ffffff;
                      border: none;
                      cursor: pointer;
                    "
                    (click)="onSaveContact()"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Popup For Edit Contact -->
          <div
            *ngIf="showContactEditModal"
            class="modal fade show d-block"
            data-bs-backdrop="static"
            id="basicModal1"
            tabindex="-1"
            style="background: rgba(0, 0, 0, 0.5)"
          >
            <div
              style="width: 400px"
              class="modal-dialog modal-dialog-centered"
            >
              <div class="modal-content">
                <div
                  style="
                    padding: 5px;
                    background-color: #142a49;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <!-- <h6 class="modal-title">{{ lang.Add_Contact }}</h6> -->
                  <h6 style="margin: 3px; background-color: #142a49">
                    Edit Contact
                  </h6>
                  <button
                    (click)="onCloseEditPopup()"
                    style="margin: 3px"
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <div class="modal-body">
                  <form class="onbordingform">
                    <!-- First row -->
                    <div style="display: flex; column-gap: 10px; width: 100%">
                      <!-- first name -->
                      <div>
                        <label class="fontSize">{{ lang.First_Name }}</label
                        ><br />
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="firstName"
                          [formControl]="contactForm.controls['firstName']"
                          placeholder="{{ lang.First_Name }}"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted &&
                            contactForm.controls['firstName'].errors
                          "
                        >
                          First name is required
                        </div>
                      </div>
                      <!-- Last name -->
                      <div>
                        <label class="fontSize">{{ lang.Last_Name }}</label
                        ><br />
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="lastName"
                          [formControl]="contactForm.controls['lastName']"
                          placeholder="{{ lang.Last_Name }}"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted && contactForm.controls['lastName'].errors
                          "
                        >
                          Last name is required
                        </div>
                      </div>
                    </div>
                    <!-- Second row -->
                    <div style="display: flex; column-gap: 10px; width: 100%">
                      <!-- Email name -->
                      <div>
                        <label class="fontSize">{{ lang.Email }}</label
                        ><br />
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="email"
                          [formControl]="contactForm.controls['email']"
                          placeholder="{{ lang.Email }}"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: lowercase;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted && contactForm.controls['email'].errors
                          "
                        >
                          <span
                            *ngIf="
                              contactForm.controls['email'].errors?.required
                            "
                            >Email is required</span
                          >
                          <span
                            *ngIf="contactForm.controls['email'].errors?.email"
                            >Invalid email</span
                          >
                        </div>
                      </div>
                      <!-- PhoneNumber name -->
                      <div>
                        <label class="fontSize">{{ lang.Phone_Number }}</label
                        ><br />
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="phone"
                          (keydown)="
                            allowOnlyNumbersForPhoneNumber($event, phone)
                          "
                          [formControl]="contactForm.controls['phone']"
                          max="10"
                          placeholder="{{ lang.Phone_Number }}"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted && contactForm.controls['phone'].errors
                          "
                        >
                          <span
                            *ngIf="
                              contactForm.controls['phone'].errors?.required
                            "
                          >
                            Phone number is required
                          </span>
                          <span
                            *ngIf="
                              contactForm.controls['phone'].errors?.pattern
                            "
                          >
                            Phone number must be exactly 10 digits
                          </span>
                        </div>
                      </div>
                    </div>
                    <!-- Third row -->
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        /* flex-wrap: wrap; */
                        column-gap: 10px;
                        width: 100%;
                        margin-top: 2px;
                      "
                    >
                      <!-- Roles -->
                      <div style="display: flex; flex-direction: column">
                        <label class="fontSize">Roles</label>
                        <select
                          [(ngModel)]="role"
                          [ngModelOptions]="{ standalone: true }"
                          (change)="onRoleChange($event)"
                          [formControl]="contactForm.controls['role']"
                          style="
                            width: 178px;
                            height: 30px;
                            line-height: 18px;
                            font-size: 13px;
                            padding: 2px 10px;
                            border: 1px solid #ccc;
                            border-radius: 5px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-sizing: border-box;
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        >
                          <option *ngFor="let role of roles" [value]="role">
                            {{ role }}
                          </option>
                        </select>
                        <div
                          class="error"
                          *ngIf="
                            submitted && contactForm.controls['role'].errors
                          "
                        >
                          Role is required
                        </div>
                      </div>

                      <div *ngIf="showOther" style="margin-top: -3px">
                        <label class="fontSize">Other</label><br />
                        <input
                          type="text"
                          [(ngModel)]="contact_other"
                          [ngModelOptions]="{ standalone: true }"
                          [formControl]="contactForm.controls['contact_other']"
                          placeholder="Enter Role"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                        <div
                          class="error"
                          *ngIf="
                            submitted &&
                            contactForm.controls['contact_other'].errors
                          "
                        >
                          Other role is required
                        </div>
                      </div>
                      <!-- Email Reporting -->
                      <div *ngIf="!showOther" style="margin-top: 15px">
                        <label
                          style="
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                          "
                        >
                          <input
                            type="checkbox"
                            [(ngModel)]="emailReports"
                            [ngModelOptions]="{ standalone: true }"
                            style="
                              margin-right: 8px;
                              width: 16px;
                              height: 16px;
                              cursor: pointer;
                            "
                          />
                          <span class="fontSize">Email Reports</span>
                        </label>
                      </div>
                    </div>
                    <!-- Email Reporting -->
                    <div *ngIf="showOther" style="margin-top: 15px">
                      <label
                        style="
                          display: flex;
                          align-items: center;
                          cursor: pointer;
                        "
                      >
                        <input
                          type="checkbox"
                          [(ngModel)]="emailReports"
                          [ngModelOptions]="{ standalone: true }"
                          style="
                            margin-right: 8px;
                            width: 16px;
                            height: 16px;
                            cursor: pointer;
                          "
                        />
                        <span class="fontSize">Email Reports</span>
                      </label>
                    </div>
                  </form>
                </div>
                <!-- close and save button -->
                <div style="margin: -7px" class="modal-footer">
                  <!-- Close Button -->
                  <button
                    class="btn btn-sm fontSize"
                    style="
                      font-size: 14px;
                      padding: 4px 12px;
                      border-radius: 4px;
                      background-color: white;
                      border: 1px solid #142a49;
                      color: #142a49;
                      cursor: pointer;
                    "
                    (click)="onCloseEditPopup()"
                  >
                    Cancel
                  </button>

                  <!-- Save Button -->
                  <button
                    class="btn btn-sm fontSize"
                    style="
                      font-size: 14px;
                      padding: 4px 12px;
                      border-radius: 4px;
                      background-color: #142a49;
                      border: 1px solid #142a49;
                      color: #ffffff;
                      border: none;
                      cursor: pointer;
                    "
                    (click)="onUpdateContact(selectedIndex)"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Popup for Delete Contact -->
          <!-- Delete Confirmation Modal -->
          <div
            *ngIf="showDeleteConfirm"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100vw;
              height: 100vh;
              background-color: rgba(0, 0, 0, 0.5);
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 9999;
            "
          >
            <div
              style="
                width: 400px;
                background-color: white;
                border-radius: 8px;
                overflow: hidden;
                font-family: Arial, sans-serif;
                box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
              "
            >
              <!-- Header -->
              <div
                style="
                  background-color: #142a49;
                  color: white;
                  font-weight: bold;
                  padding: 10px 16px;
                  font-size: 16px;
                  text-align: center;
                "
              >
                Alert
              </div>

              <!-- Message -->
              <div style="padding: 20px; font-size: 15px; text-align: center">
                <p style="margin: 0">
                  Are you sure you want to delete this Group Contact?
                </p>
                <p style="margin-top: 8px; font-weight: bold">
                  {{ selectedContact.name }} - {{ selectedContact.role }}
                  <!-- {{ selectedContact?.name }} ({{ selectedContact?.role }}) -->
                </p>
              </div>

              <!-- Buttons -->
              <div
                style="
                  display: flex;
                  justify-content: center;
                  padding: 0 0 14px 0;
                  gap: 12px;
                "
              >
                <button
                  (click)="onConfirmDelete(indexNumberForDelete)"
                  style="
                    padding: 5px 14px;
                    background-color: #142a49;
                    color: white;
                    border: none;
                    border-radius: 6px;
                    font-size: 14px;
                    cursor: pointer;
                  "
                >
                  Proceed
                </button>
                <button
                  (click)="onCancelDelete()"
                  style="
                    padding: 5px 14px;
                    background-color: white;
                    color: #0b2e67;
                    border: 1px solid #0b2e67;
                    border-radius: 6px;
                    font-size: 14px;
                    cursor: pointer;
                  "
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Vendor Invoicing and Payment Method -->
        <br />
        <!-- contacts.length > 0 && supplierName?.length > 3; -->
        <div
          *ngIf="!matchedSupplierName && supplierName?.length > 0"
          style="width: 100%; display: flex; flex-direction: column"
        >
          <!-- Vendor Invoicing and payments Header -->
          <div
            class="header-height"
            style="
              background: #142a49;
              color: white;
              border-top: 1px solid #ddd;
              border-radius: 3px;
            "
          >
            <label
              class="headingFontSize"
              style="background: #142a49; margin-left: 15px"
            >
              Vendor Invoicing and Payment Method&nbsp;<i
                class="bi bi-info-circle"
              ></i>
            </label>
          </div>
          <!-- new code star from here -->
          <div
            style="
              display: flex;
              gap: 20px;
              margin-top: -3px;
              align-items: flex-start;
            "
          >
            <!-- self billing and invoiced button -->
            <div
              [ngStyle]="{
                display: 'flex',
                flexDirection: billingType ? 'column' : 'row',
                rowGap: '0px',
                padding: '10px'
              }"
            >
              <!-- Yes - Self Billing -->
              <div
                style="
                  display: flex;
                  align-items: center;
                  gap: 10px;
                  width: 100px;
                "
              >
                <input
                  [(ngModel)]="billingType"
                  value="self-billing"
                  (ngModelChange)="validateField('billingType', billingType)"
                  type="radio"
                  name="billingType"
                  style="cursor: pointer"
                />
                <label class="fontSize">Self Billing</label>
              </div>

              <!-- No - Invoiced -->
              <div
                style="
                  display: flex;
                  align-items: center;
                  gap: 10px;
                  width: 100px;
                "
              >
                <input
                  [(ngModel)]="billingType"
                  value="invoiced"
                  type="radio"
                  (change)="onBillingTypeChange()"
                  name="billingType"
                  (ngModelChange)="validateField('billingType', billingType)"
                  style="cursor: pointer"
                />
                <label class="fontSize">Invoiced</label>
              </div>
              <!-- show error  -->
              <div class="error" *ngIf="true">
                {{ errors.billingType }}
              </div>
            </div>
            <!-- payment method  -->
            <div
              *ngIf="billingType"
              [ngStyle]="{
                display: 'flex',
                flexDirection: 'column',
                width: billingType === 'invoiced' ? 'auto' : '100%',
                marginTop: '7px'
              }"
            >
              <div style="display: flex">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    flex-wrap: wrap;
                    padding-left: 15px;
                    margin-top: 2px;
                    row-gap: 3px;
                  "
                >
                  <!-- expected payment date -->
                  <div
                    *ngIf="billingType !== 'self-billing'"
                    style="display: flex"
                  >
                    <div
                      style="
                        width: 130px;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                      "
                    >
                      <input
                        type="radio"
                        name="PAD"
                        [(ngModel)]="paymentOption"
                        (ngModelChange)="onPaymentOptionChange($event)"
                        value="PAD From GB"
                        style="cursor: pointer"
                      />
                      <label class="fontSize">PAD From GB</label>
                    </div>
                  </div>
                  <!-- EFT to Vendor -->
                  <div style="display: flex">
                    <div
                      style="
                        width: 130px;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                      "
                    >
                      <input
                        *ngIf="billingType === 'invoiced'"
                        type="radio"
                        name="PAD"
                        [(ngModel)]="paymentOption"
                        (ngModelChange)="onPaymentOptionChange($event)"
                        value="EFT to Vendor"
                        style="cursor: pointer"
                      />
                      <label class="fontSize">EFT to Vendor</label>
                    </div>
                  </div>
                </div>
                <!-- Expected Payment Date mm/dd/yyyy -->
                <div
                  *ngIf="billingType !== 'self-billing'"
                  style="margin-top: 1px; display: flex; flex-direction: column"
                >
                  <label
                    *ngIf="paymentOption === 'PAD From GB'"
                    class="fontSize"
                    >Expected Payment Date</label
                  >
                  <input
                    *ngIf="paymentOption === 'PAD From GB'"
                    type="date"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="expected_Payment_Date"
                    (ngModelChange)="
                      validateField(
                        'expected_Payment_Date',
                        expected_Payment_Date
                      )
                    "
                    class="fontSize"
                    style="
                      width: 100%;
                      height: 30px;
                      padding: 6px 10px;
                      font-size: 14px;
                      border: 1px solid #ccc;
                      border-radius: 6px;
                      outline: none;
                      background-color: #e8eaf0;
                      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                      transition: box-shadow 0.2s ease, border-color 0.2s ease;
                    "
                    onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6b7280';"
                    onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#8b8b8b';"
                  />
                  <div class="error" *ngIf="errors.expectedPaymentDate">
                    {{ errors.expectedPaymentDate }}
                  </div>
                </div>
                <!-- All codes -->
                <div
                  *ngIf="
                    billingType === 'self-billing' ||
                    paymentOption === 'EFT to Vendor'
                  "
                  style="
                    display: flex;
                    width: auto;
                    gap: 10px;
                    margin-top: -1px;
                  "
                >
                  <div>
                    <div>
                      <label class="fontSize">{{ lang.Bank_Code }}</label
                      ><br />
                      <input
                        type="text"
                        [(ngModel)]="bank_code"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="validateField('bank_code', bank_code)"
                        (keydown)="allowOnlyNumbers($event)"
                        style="
                          width: 100%;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      />
                      <div class="error" *ngIf="errors.bankCode">
                        {{ errors.bankCode }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <label class="fontSmallSize">{{ lang.Transit }}</label
                      ><br />
                      <input
                        type="text"
                        [(ngModel)]="transit"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="validateField('transit', transit)"
                        (keydown)="allowOnlyNumbers($event)"
                        style="
                          width: 100%;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      />
                      <div class="error" *ngIf="errors.transit">
                        {{ errors.transit }}
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <label class="fontSmallSize">Acc No</label><br />
                      <input
                        type="text"
                        [(ngModel)]="account_number"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="
                          validateField('account_number', account_number)
                        "
                        (keydown)="allowOnlyNumbers($event)"
                        style="
                          width: 100%;
                          height: 30px;
                          padding: 6px 10px;
                          font-size: 14px;
                          border: 1px solid #ccc;
                          border-radius: 6px;
                          outline: none;
                          background-color: #e8eaf0;
                          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                          transition: box-shadow 0.2s ease,
                            border-color 0.2s ease;
                        "
                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                      />
                      <div class="error" *ngIf="errors.accountNumber">
                        {{ errors.accountNumber }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Product Currency -->
            <!-- Self Billing -->
            <div style="margin-top: 6px; min-width: 150px">
              <label class="fontSize">Product Currency</label><br />
              <ng-multiselect-dropdown
                [placeholder]="'Select Currency'"
                [settings]="countryDropdownSettings"
                [data]="currencies"
                (onSelect)="validateProductCurrency(productCurrency)"
                (onDeSelect)="validateProductCurrency(productCurrency)"
                [(ngModel)]="productCurrency"
                style="
                  font-size: 11px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  text-transform: capitalize;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              >
              </ng-multiselect-dropdown>
              <div class="error" *ngIf="errors.pcurrency">
                {{ errors.pcurrency }}
              </div>
            </div>
          </div>
          <!-- Expected Payment Date mm/dd/yyyy -->
        </div>
        <!-- Vendor Address -->
        <br />
        <!-- *ngIf="
          contacts.length > 0 &&
          supplierName?.length > 3 &&
          !matchedSupplierName &&
          isProductValidForVendorAndPricing
        " -->
        <div
          *ngIf="!matchedSupplierName && supplierName?.length > 0"
          style="width: 100%; display: flex; flex-direction: column"
        >
          <!-- Vendor Invoicing and payments Header -->
          <div
            class="header-height"
            style="
              background: #142a49;
              color: white;
              border-top: 1px solid #ddd;
              border-radius: 3px;
            "
          >
            <label
              class="headingFontSize"
              style="background: #142a49; margin-left: 15px"
            >
              Vendor Address&nbsp;<i class="bi bi-info-circle"></i>
            </label>
          </div>
          <!-- new code star from here -->
          <div
            style="
              padding-left: 15px;
              display: flex;
              flex-wrap: wrap;
              gap: 15px;
            "
          >
            <!-- Street Address -->
            <div style="flex: 1 1 38%; min-width: 200px">
              <label class="fontSize">Street Address </label>
              <input
                type="text"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="streetAddress"
                (ngModelChange)="validateField('streetAddress', streetAddress)"
                placeholder="Street Address"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              />
              <div class="error" *ngIf="errors.streetAddress">
                {{ errors.streetAddress }}
              </div>
            </div>

            <!-- Street Address Line 2 -->
            <div style="flex: 1 1 38%; min-width: 200px">
              <label class="fontSize">Street Address Line 2</label>
              <input
                type="text"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="streetAddress2"
                placeholder="Street Address Line 2"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              />
            </div>

            <!-- Unit/Apt/Suite -->
            <div style="flex: 1 1 20%; min-width: 160px">
              <label class="fontSize">Unit/Apt/Suite #</label>
              <input
                type="text"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="validateField('unitNumber', unitNumber)"
                [(ngModel)]="unitNumber"
                placeholder="Unit/Apt/Suite #"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              />
              <div class="error" *ngIf="errors.unitNumber">
                {{ errors.unitNumber }}
              </div>
            </div>

            <!-- City -->
            <div style="flex: 1 1 22%; min-width: 160px">
              <label class="fontSize">City </label>
              <input
                type="text"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="city"
                (ngModelChange)="validateField('city', city)"
                placeholder="City"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              />
              <div class="error" *ngIf="errors.city">{{ errors.city }}</div>
            </div>

            <!-- Country -->
            <div style="flex: 1 1 22%; min-width: 160px">
              <label class="fontSize">Country </label>
              <ng-multiselect-dropdown
                [placeholder]="'Select Country'"
                [settings]="countryDropdownSettings"
                (onSelect)="validateCountry(selectedCountry)"
                (onDeSelect)="validateCountry(selectedCountry)"
                [data]="countries"
                [(ngModel)]="selectedCountry"
                style="
                  font-size: 11px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  text-transform: capitalize;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              >
              </ng-multiselect-dropdown>
              <div class="error" *ngIf="errors.country">
                {{ errors.country }}
              </div>
            </div>

            <!-- Province -->
            <!-- Province Dropdown -->
            <div style="flex: 1 1 22%; min-width: 160px">
              <label class="fontSize">Province </label>
              <ng-multiselect-dropdown
                [placeholder]="'Select Province'"
                [settings]="vendorAddressSettings"
                [data]="provinces"
                [(ngModel)]="selectedProvince"
                (ngModelChange)="
                  validateField('selectedProvince', selectedProvince)
                "
                style="
                  font-size: 11px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                  text-transform: capitalize;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              >
              </ng-multiselect-dropdown>
              <div
                class="error"
                *ngIf="errors.selectedProvince && this.isSubmitedSupplier"
              >
                {{ errors.selectedProvince }}
              </div>
            </div>

            <!-- Postal Code -->
            <div style="flex: 1 1 22%; min-width: 160px">
              <label class="fontSize">Postal Code </label>
              <input
                type="text"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="postalCode"
                (ngModelChange)="validateField('postalCode', $event)"
                placeholder="Ex: K1A 0B1"
                style="
                  width: 100%;
                  height: 30px;
                  padding: 6px 10px;
                  font-size: 14px;
                  border: 1px solid #ccc;
                  border-radius: 6px;
                  outline: none;
                  background-color: #e8eaf0;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                  transition: box-shadow 0.2s ease, border-color 0.2s ease;
                "
                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
              />
              <div class="error" *ngIf="errors.postalCode">
                {{ errors.postalCode }}
              </div>
            </div>
          </div>
        </div>

        <!-- Provisioning and Reporting -->
        <br />
        <!-- Add Product Section Popup (also inside the card) -->
        <!-- *ngIf="
          contacts.length > 0 &&
          supplierName?.length > 3 &&
          !matchedSupplierName && isProductValidForVendorAndPricing && validateAddress()
        " -->
        <div *ngIf="!matchedSupplierName && supplierName?.length > 0">
          <!-- <div> -->
          <!-- Add Product Section Header -->
          <div
            class="header-height"
            style="
              background: #142a49;
              color: white;
              border-top: 1px solid #ddd;
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: relative;
              border-radius: 3px;
            "
          >
            <h3
              class="headingFontSize"
              style="
                margin-left: 10px;
                background-color: #142a49;
                margin-top: 9px;
              "
            >
              {{ lang.Product_Information }}&nbsp;<i
                class="bi bi-info-circle"
              ></i>
            </h3>
            <button
              (click)="onProductModel()"
              style="
                position: absolute;
                right: 3px;
                background-color: white;
                color: #142a49;
                border: 1px solid #707070;
                border-radius: 4px;
                padding: 2.5px 15px;
                font-size: 13px;
                cursor: pointer;
                margin: 3px;
              "
            >
              + {{ lang.Add }}
            </button>
          </div>

          <!--It is Popup for Adding Product Fields -->
          <div
            *ngIf="showProductModal"
            class="modal fade show d-block"
            id="basicModal1"
            tabindex="-1"
            style="background: rgba(0, 0, 0, 0.5)"
          >
            <div
              class="modal-dialog modal-dialog-centered"
              style="width: 100vw; max-width: 100%; margin: 0; padding: 10px"
            >
              <div
                class="modal-content"
                style="
                  height: 95vh;
                  max-height: 95vh;
                  overflow-y: auto;
                  display: flex;
                  flex-direction: column;
                "
              >
                <!-- Sticky Header -->
                <!-- Sticky Header -->
                <div
                  class="header-height"
                  style="
                    position: sticky;
                    top: 0;
                    z-index: 100;
                    background-color: #142a49;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: white;
                    min-height: 29px;
                  "
                >
                  <label
                    class="headingFontSize"
                    style="background-color: #142a49; margin-left: 15px"
                  >
                    {{ lang.Add_Product }}
                  </label>

                  <button
                    (click)="showProductModal = false"
                    type="button"
                    class="btn-close"
                    style="width: 10px; height: 10px; margin-right: 5px"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>

                <!-- this is products field -->
                <div>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      flex-wrap: wrap;
                      gap: 15px;
                    "
                  >
                    <!-- my first row -->
                    <div
                      class="my-first-row"
                      [ngClass]="showOtherInput ? 'my-first-row-wrap' : ''"
                      style="
                        display: flex;
                        gap: 10px;
                        width: 100%;
                        justify-content: space-between;
                        padding: 15px;
                      "
                    >
                      <!-- Product ID -->
                      <div style="flex: 1 1 13%; min-width: 160px">
                        <label class="fontSize">{{ lang.Product_ID }}</label>
                        <input
                          disabled
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="product_ID"
                          placeholder="{{ lang.Product_ID }}"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                      </div>

                      <!-- Product Name -->
                      <div style="flex: 1 1 13%; min-width: 160px">
                        <label class="fontSize">{{ lang.Product_Name }}</label>
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="product_name"
                          placeholder="{{ lang.Product_Name }}"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                      </div>

                      <!-- Product Identifier -->
                      <div style="flex: 1 1 13%; min-width: 160px">
                        <label class="fontSize">Product Identifier</label>
                        <ng-multiselect-dropdown
                          [placeholder]="'Select One'"
                          [settings]="countryDropdownSettings"
                          [data]="productIdentifier"
                          [(ngModel)]="product_indetifier"
                          (onSelect)="onSelectProductIdentityFier($event)"
                          (onDeSelect)="onDeselectProductIdentityFier($event)"
                          style="
                            font-size: 11px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        >
                        </ng-multiselect-dropdown>
                      </div>
                      <div
                        *ngIf="showOtherInput"
                        style="flex: 1 1 13%; min-width: 160px"
                      >
                        <label class="fontSize">New Product Identifier</label>
                        <input
                          type="text"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="otherInputForProductIdentiFier"
                          placeholder="Enter new name"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                      </div>
                      <!-- Eff Dist Date -->
                      <div style="flex: 1 1 13%; min-width: 160px">
                        <label class="fontSize"
                          >Effective Distribution Date</label
                        >
                        <input
                          type="date"
                          [ngModelOptions]="{ standalone: true }"
                          [(ngModel)]="effective_Distribution_Date"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                      </div>

                      <!-- Dist Country -->
                      <!-- Dist Country -->
                      <div style="flex: 1 1 13%; min-width: 160px">
                        <label class="fontSize">Distribution Country</label>
                        <ng-multiselect-dropdown
                          [placeholder]="'Select Country'"
                          [settings]="countryDropdownSettings"
                          [data]="countries"
                          [(ngModel)]="product_country"
                          style="
                            font-size: 11px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        >
                        </ng-multiselect-dropdown>
                      </div>

                      <!-- Distribution Provinces -->
                      <div style="flex: 1 1 13%; min-width: 160px">
                        <label class="fontSize">Distribution Provinces</label>
                        <ng-multiselect-dropdown
                          [placeholder]="'Select Provinces'"
                          [settings]="dropdownSettings"
                          [data]="provinces"
                          [(ngModel)]="selectedProvinces"
                          (onSelect)="onItemSelect($event)"
                          (onDeSelect)="onItemDeSelect($event)"
                          (onSelectAll)="onSelectAll($event)"
                          (onDeSelectAll)="onDeSelectAll($event)"
                          style="
                            font-size: 11px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                            text-transform: capitalize;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        >
                        </ng-multiselect-dropdown>
                      </div>

                      <!-- Renewal Date -->
                      <div
                        [ngStyle]="{
                          flex: '1 1 13%',
                          'max-width': showOtherInput ? '160px' : null,
                          'min-width': !showOtherInput ? '160px' : null
                        }"
                      >
                        <label class="fontSize">Renewal Date</label>

                        <input
                          type="date"
                          [(ngModel)]="renewalDate"
                          [ngModelOptions]="{ standalone: true }"
                          style="
                            width: 100%;
                            height: 30px;
                            padding: 6px 10px;
                            font-size: 14px;
                            border: 1px solid #ccc;
                            border-radius: 6px;
                            outline: none;
                            background-color: #e8eaf0;
                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            transition: box-shadow 0.2s ease,
                              border-color 0.2s ease;
                          "
                          onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                          onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                        />
                      </div>
                    </div>

                    <!-- BREAK LINE -->

                    <!-- Service Level AND Limits -->
                    <div *ngIf="isProductValidForFirstRow" style="width: 100%">
                      <!-- Limits -->
                      <div
                        style="
                          width: 100%;
                          display: flex;
                          flex-direction: column;
                        "
                      >
                        <!-- Section Header -->
                        <div
                          class="header-height"
                          style="
                            background: #142a49;
                            color: white;
                            border-top: 1px solid #ddd;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            position: relative;
                          "
                        >
                          <label
                            class="headingFontSize"
                            style="background: #142a49; margin-left: 15px"
                          >
                            Limits&nbsp;<i class="bi bi-info-circle"></i>
                          </label>
                        </div>

                        <div
                          class="limits"
                          style="
                            display: flex;
                            width: fit-content;
                            column-gap: 30px;
                            padding-left: 5px;
                          "
                        >
                          <!-- COB rules -->
                          <div
                            style="
                              padding: 10px;
                              display: flex;
                              align-items: center;
                              column-gap: 10px;
                            "
                          >
                            <label class="fontSize"
                              >C. O. B. Rules Apply?</label
                            >
                            <div style="display: flex; align-items: center">
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 5px;
                                  font-size: 13px;
                                  margin-right: 10px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="COB"
                                  [(ngModel)]="isCOB"
                                  [value]="true"
                                  style="cursor: pointer"
                                />
                                Yes
                              </label>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 5px;
                                  font-size: 13px;
                                "
                              >
                                <input
                                  type="radio"
                                  [value]="false"
                                  [(ngModel)]="isCOB"
                                  name="COB"
                                  style="cursor: pointer"
                                />
                                No
                              </label>
                            </div>
                          </div>
                          <!-- Fields Wrapper -->
                          <div
                            style="
                              display: flex;
                              flex-wrap: wrap;
                              padding: 10px;
                              gap: 20px;
                              align-items: center;
                            "
                          >
                            <!-- Age Limited Radio -->
                            <div
                              class="fontSize"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                              "
                            >
                              <label
                                class="fontSize"
                                style="margin-right: 10px"
                                >{{ lang.Age_Limited }}</label
                              >
                              <label
                                style="
                                  font-size: 13px;
                                  display: flex;
                                  align-items: center;
                                "
                              >
                                <input
                                  type="radio"
                                  [(ngModel)]="age_"
                                  name="ageLimit"
                                  [value]="true"
                                  style="margin-right: 5px; cursor: pointer"
                                />
                                Yes
                              </label>
                              <label
                                style="
                                  font-size: 13px;
                                  display: flex;
                                  align-items: center;
                                "
                              >
                                <input
                                  type="radio"
                                  [(ngModel)]="age_"
                                  (change)="resetAgeFields()"
                                  name="ageLimit"
                                  [value]="false"
                                  style="margin-right: 5px; cursor: pointer"
                                />
                                No
                              </label>
                            </div>

                            <!-- Age Inputs -->
                            <div
                              *ngIf="age_"
                              style="
                                display: flex;
                                flex-wrap: wrap;
                                gap: 10px;
                                align-items: flex-end;
                                margin-top: -5px;
                              "
                            >
                              <div
                                style="
                                  display: flex;
                                  flex-direction: column;
                                  width: 80px;
                                "
                              >
                                <label class="fontSmallSize">{{
                                  lang.Min_Age
                                }}</label>
                                <input
                                  type="number"
                                  [(ngModel)]="minAge"
                                  [ngModelOptions]="{ standalone: true }"
                                  (input)="validateAgeRange()"
                                  style="
                                    width: 100%;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                />
                              </div>

                              <div
                                style="
                                  display: flex;
                                  flex-direction: column;
                                  width: 80px;
                                "
                              >
                                <label class="fontSmallSize">{{
                                  lang.Max_Age
                                }}</label>
                                <input
                                  type="number"
                                  [(ngModel)]="maxAge"
                                  [ngModelOptions]="{ standalone: true }"
                                  (input)="validateAgeRange()"
                                  style="
                                    width: 100%;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                />
                              </div>

                              <div
                                style="
                                  display: flex;
                                  flex-direction: column;
                                  width: 80px;
                                "
                              >
                                <label
                                  class="fontSmallSize"
                                  style="width: 110px"
                                  >Child Age Out</label
                                >
                                <input
                                  type="number"
                                  [(ngModel)]="childAgeOut"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 100%;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                />
                              </div>

                              <div
                                style="
                                  display: flex;
                                  flex-direction: column;
                                  width: 80px;
                                "
                              >
                                <label
                                  class="fontSmallSize"
                                  style="width: 110px"
                                  >Student Age Out</label
                                >
                                <input
                                  type="number"
                                  [(ngModel)]="studentAgeOut"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 100%;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                />
                              </div>
                            </div>
                            <!-- Error Message -->
                            <div
                              *ngIf="ageError"
                              style="
                                color: red;
                                font-size: 12px;
                                margin-top: 5px;
                              "
                            >
                              {{ ageError }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- BREAK LINE -->

                    <!-- Product Details and Vendor Invoicing and payments -->
                    <div
                      class="product_details"
                      *ngIf="isProductValidForFirstRow"
                      style="width: 100%; display: flex; column-gap: 10px"
                    >
                      <div
                        style="
                          width: 100%;
                          display: flex;
                          flex-direction: column;
                        "
                      >
                        <!-- heading of product details -->
                        <div
                          class="header-height"
                          style="
                            width: 100%;
                            background: #142a49;
                            color: white;
                            border-top: 1px solid #ddd;
                          "
                        >
                          <label
                            class="headingFontSize"
                            style="margin-left: 15px; background-color: #142a49"
                          >
                            {{ lang.Product_Details }}&nbsp;<i
                              class="bi bi-info-circle"
                            ></i>
                          </label>
                        </div>

                        <div style="display: flex; margin-top: -7px">
                          <!--Booklet Template -->

                          <!--Toolkit Template -->
                          <div
                            style="
                              width: 100%;
                              padding: 10px;
                              padding-left: 15px;
                            "
                          >
                            <label class="fontSize">Booklet</label><br />
                            <div
                              style="
                                position: relative;
                                width: 100%;
                                height: 34px;
                              "
                            >
                              <input
                                type="file"
                                (change)="handleBookletFile($event)"
                                id="ToolkitUpload"
                                accept="application/pdf"
                                multiple
                                style="display: none"
                              />
                              <label
                                for="ToolkitUpload"
                                style="
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  width: 100%;
                                  height: 30px;
                                  font-size: 13px;
                                  border: 1px solid #ccc;
                                  border-radius: 5px;
                                  background: #e8eaf0;
                                  cursor: pointer;
                                  padding-right: 36px;
                                  box-sizing: border-box;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: all 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#3b82f6';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                onmouseover="this.style.boxShadow='0 2px 5px rgba(0,0,0,0.10)'"
                                onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'"
                              >
                                Choose File
                              </label>

                              <!-- Eye Icon -->
                              <div
                                *ngIf="selectedFiles.length > 0"
                                (click)="showPopup = true"
                                style="
                                  position: absolute;
                                  top: 45%;
                                  right: 10px;
                                  transform: translateY(-50%);
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  height: 100%;
                                "
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="#0c2d48"
                                  style="cursor: pointer"
                                >
                                  <path
                                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 
         11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
         5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 
         3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                                  />
                                </svg>
                                <span
                                  style="
                                    font-size: 14px;
                                    margin-left: 2px;
                                    margin-top: -2px;
                                  "
                                  >{{ selectedFiles.length }}</span
                                >
                              </div>
                            </div>

                            <!-- Show File Name -->
                            <div
                              *ngIf="selectedFiles.length > 0"
                              style="width: 100%; font-size: 12px; color: #333"
                            >
                              <strong
                                >{{
                                  selectedFiles.length === 1 ? "File" : "File's"
                                }}
                                Uploaded</strong
                              >
                            </div>
                          </div>

                          <!-- Toolkit Popup  -->
                          <div
                            *ngIf="showPopup"
                            class="modal fade show d-block"
                            data-bs-backdrop="static"
                            tabindex="-1"
                            style="background: rgba(0, 0, 0, 0.5)"
                          >
                            <div
                              class="modal-dialog modal-lg modal-dialog-centered"
                              style="width: 40%"
                            >
                              <div
                                class="modal-content"
                                style="border-radius: 8px; overflow: hidden"
                              >
                                <!-- Header -->
                                <div
                                  class="header-height"
                                  style="
                                    background-color: #5d7c9b;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    padding: 10px 15px;
                                  "
                                >
                                  <h6
                                    style="
                                      color: white;
                                      margin: 0;
                                      font-size: 16px;
                                      font-weight: 600;
                                      background-color: #5d7c9b;
                                    "
                                  >
                                    Uploaded PDF List
                                  </h6>
                                  <button
                                    (click)="showPopup = false"
                                    type="button"
                                    class="btn-close"
                                    style="filter: invert(1); opacity: 0.9"
                                  ></button>
                                </div>

                                <!-- Body -->
                                <div
                                  style="
                                    padding: 16px;
                                    max-height: 300px;
                                    overflow-y: auto;
                                  "
                                >
                                  <div
                                    *ngFor="
                                      let pdf of selectedFiles;
                                      let i = index
                                    "
                                    style="
                                      display: flex;
                                      align-items: center;
                                      justify-content: space-between;
                                      padding: 8px 0;
                                      border-bottom: 1px solid #e0e0e0;
                                    "
                                  >
                                    <!-- File Name -->
                                    <span
                                      style="
                                        flex: 1;
                                        font-size: 14px;
                                        color: #333;
                                      "
                                    >
                                      {{ pdf.name }}
                                    </span>

                                    <!-- Eye Icon -->
                                    <span
                                      (click)="viewPdf(pdf.url, pdf.name)"
                                      style="
                                        margin-right: 10px;
                                        cursor: pointer;
                                      "
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="#0c2d48"
                                      >
                                        <path
                                          d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 
              11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
              5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 
              3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                                        />
                                      </svg>
                                    </span>

                                    <!-- Delete Icon -->
                                    <span
                                      (click)="deletePdf(i)"
                                      style="cursor: pointer; color: #b22222"
                                    >
                                      <i class="bi bi-trash-fill"></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- PDF Popup -->
                          <div
                            *ngIf="showToolkitPDF"
                            class="modal fade show d-block"
                            data-bs-backdrop="static"
                            tabindex="-1"
                            style="background: rgba(0, 0, 0, 0.5)"
                          >
                            <div
                              style="width: 40%"
                              class="modal-dialog modal-lg modal-dialog-centered"
                            >
                              <div class="modal-content">
                                <!-- Header -->
                                <div
                                  class="header-height"
                                  style="
                                    background-color: #5d7c9b;
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    padding: 10px 15px;
                                  "
                                >
                                  <h6
                                    class="fontSize"
                                    style="
                                      color: white;
                                      margin: 0;
                                      background-color: #5d7c9b;
                                    "
                                  >
                                    Preview : {{ currentPDFName }}
                                  </h6>
                                  <button
                                    (click)="showToolkitPDF = false"
                                    style="margin: 3px"
                                    type="button"
                                    class="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>

                                <!-- Body -->
                                <iframe
                                  [src]="currentPdfUrl"
                                  width="100%"
                                  height="500px"
                                ></iframe>
                              </div>
                            </div>
                          </div>

                          <!-- Product Resource Info -->
                          <div
                            style="
                              width: 100%;
                              padding: 10px;
                              padding-left: 15px;
                            "
                          >
                            <label class="fontSize">Product Resource Info</label
                            ><br />
                            <div
                              style="
                                position: relative;
                                width: 100%;
                                height: 34px;
                                margin-bottom: -6px;
                              "
                            >
                              <!-- (click)="onProductResourceInfoCreate()" -->
                              <label
                                (click)="
                                  showProduct_Resource_QuillEditor = true
                                "
                                for="Resource"
                                style="
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  width: 100%;
                                  height: 30px;
                                  font-size: 13px;
                                  border: 1px solid #ccc;
                                  border-radius: 5px;
                                  background: #e8eaf0;
                                  cursor: pointer;
                                  padding-right: 36px;
                                  box-sizing: border-box;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: all 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#3b82f6';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                onmouseover="this.style.boxShadow='0 2px 5px rgba(0,0,0,0.10)'"
                                onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'"
                              >
                                {{
                                  savedProductResourceContent
                                    ? "Edit File"
                                    : "Create File"
                                }}
                              </label>

                              <!-- Eye Icon -->
                              <div
                                *ngIf="savedProductResourceContent"
                                (click)="onViewProduct_Resource_Description()"
                                style="
                                  position: absolute;
                                  top: 45%;
                                  right: 10px;
                                  transform: translateY(-50%);
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  height: 100%;
                                "
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="#0c2d48"
                                  style="cursor: pointer"
                                >
                                  <path
                                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 
         11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
         5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 
         3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                                  />
                                </svg>
                              </div>
                            </div>

                            <!-- saved name -->
                            <!-- saved name -->
                            <span
                              *ngIf="savedProductResourceContent"
                              style="
                                font-size: 12px;
                                font-weight: 500;
                                color: darkgrey;
                              "
                              >Saved File</span
                            >
                          </div>

                          <!--************************** *Tile Description ***************************////////////-->
                          <div
                            style="
                              width: 100%;
                              padding: 10px;
                              padding-left: 15px;
                            "
                          >
                            <label class="fontSize">Tile Description</label
                            ><br />

                            <div
                              style="
                                position: relative;
                                width: 100%;
                                height: 34px;
                                margin-bottom: -6px;
                              "
                            >
                              <!-- Styled Label as Fake Button -->
                              <!-- <label
                                (click)="onTileFileCreate()" -->
                              <label
                                (click)="showTileQuillEditor = true"
                                for="bookletUpload"
                                style="
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  width: 100%;
                                  height: 30px;
                                  font-size: 13px;
                                  border: 1px solid #ccc;
                                  border-radius: 5px;
                                  background: #e8eaf0;
                                  cursor: pointer;
                                  padding-right: 36px;
                                  box-sizing: border-box;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: all 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#3b82f6';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                onmouseover="this.style.boxShadow='0 2px 5px rgba(0,0,0,0.10)'"
                                onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'"
                              >
                                {{ savedContent ? "Edit File" : "Create File" }}
                              </label>

                              <!-- Eye Icon -->
                              <div
                                *ngIf="savedContent"
                                (click)="onViewTileDescription()"
                                style="
                                  position: absolute;
                                  top: 45%;
                                  right: 10px;
                                  transform: translateY(-50%);
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  height: 100%;
                                "
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="#0c2d48"
                                  style="cursor: pointer"
                                >
                                  <path
                                    d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 
          11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
          5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 
          3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                                  />
                                </svg>
                              </div>
                            </div>

                            <!-- saved name -->
                            <span
                              *ngIf="savedContent"
                              style="
                                font-size: 12px;
                                font-weight: 500;
                                color: darkgrey;
                              "
                              >Saved File</span
                            >
                          </div>
                        </div>

                        <!-- question + akash +george -->
                        <!-- Health Card/Certificate Section -->
                        <div
                          style="
                            padding-left: 15px;
                            display: flex;
                            flex-direction: column;
                            row-gap: 10px;
                          "
                        >
                          <div
                            style="
                              display: flex;
                              align-items: flex-start; /* horizontal alignment */
                              gap: 20px; /* reduced gap between Q1 and Q2 */
                              margin-top: 10px;
                            "
                          >
                            <!-- Q1: Does this product have any health card/certificate? -->
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                gap: 6px; /* reduced gap between label and radios */
                              "
                            >
                              <label
                                style="
                                  font-size: 14px;
                                  width: 320px; /* increased width so text stays in one line */
                                "
                              >
                                Does this product have any health
                                card/certificate?
                              </label>

                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 10px;
                                  font-size: 13px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="hasCard"
                                  [(ngModel)]="hasHealthCard"
                                  [value]="true"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="cursor: pointer"
                                />
                                Yes
                              </label>

                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 4px;
                                  font-size: 13px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="hasCard"
                                  [(ngModel)]="hasHealthCard"
                                  [value]="false"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="cursor: pointer"
                                />
                                No
                              </label>
                            </div>

                            <!-- Q2: If Yes -> Number of cards/certificates -->
                            <div
                              *ngIf="hasHealthCard"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 6px; /* reduced gap between label and input */
                                margin-top: -5px;
                              "
                            >
                              <label
                                style="
                                  font-size: 14px;
                                  width: 150px; /* smaller since text is short */
                                "
                              >
                                No. of cards/certificates
                              </label>

                              <input
                                type="text"
                                [(ngModel)]="numCards"
                                min="1"
                                (keydown)="validateInteger($event)"
                                (paste)="validatePaste($event)"
                                [ngModelOptions]="{ standalone: true }"
                                (ngModelChange)="onNumCardsChange($event)"
                                placeholder="No. of cards/certificates"
                                style="
                                  height: 30px;
                                  padding: 6px 10px;
                                  font-size: 14px;
                                  border: 1px solid #ccc;
                                  border-radius: 6px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              />
                            </div>
                          </div>

                          <!-- Q3: Dynamic table for each card/certificate -->
                          <div
                            *ngIf="hasHealthCard && numCards > 0"
                            style="padding-right: 5px; padding-bottom: 2px"
                          >
                            <div
                              style="
                                width: 100%;
                                max-width: 600px;
                                margin-top: 5px;
                              "
                            >
                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 12px;
                                  border: 1px solid #ccc;
                                "
                              >
                                <thead
                                  style="background: #808285; color: white"
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 10%;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                        text-align: center;
                                      "
                                    >
                                      No
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 45%;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Card/Certificate Type
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 45%;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Source
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <tr *ngFor="let row of cards; let i = index">
                                    <!-- # -->
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                        text-align: center;
                                      "
                                    >
                                      {{ i + 1 }}
                                    </td>

                                    <!-- Type dropdown (single-select) -->
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      <ng-multiselect-dropdown
                                        [placeholder]="'Select Type'"
                                        [settings]="
                                          singleSelectDropdownSettings
                                        "
                                        [data]="cardTypeOptions"
                                        [(ngModel)]="cards[i].type"
                                        [ngModelOptions]="{ standalone: true }"
                                        style="
                                          font-size: 11px;
                                          outline: none;
                                          background-color: #e8eaf0;
                                          box-shadow: 0 1px 3px
                                            rgba(0, 0, 0, 0.08);
                                          transition: box-shadow 0.2s ease,
                                            border-color 0.2s ease;
                                          text-transform: capitalize;
                                        "
                                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                      >
                                      </ng-multiselect-dropdown>
                                    </td>

                                    <!-- Source dropdown (single-select) -->
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      <ng-multiselect-dropdown
                                        [placeholder]="'Select Source'"
                                        [settings]="
                                          singleSelectDropdownSettings
                                        "
                                        [data]="cardSourceOptions"
                                        [(ngModel)]="cards[i].source"
                                        [ngModelOptions]="{ standalone: true }"
                                        style="
                                          font-size: 11px;
                                          outline: none;
                                          background-color: #e8eaf0;
                                          box-shadow: 0 1px 3px
                                            rgba(0, 0, 0, 0.08);
                                          transition: box-shadow 0.2s ease,
                                            border-color 0.2s ease;
                                          text-transform: capitalize;
                                        "
                                        onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                        onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                      >
                                      </ng-multiselect-dropdown>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Vendor Invoicing and payments -->
                    </div>

                    <!-- Pricing Area AND Age Binding -->
                    <!-- heading of Pricing -->
                    <div *ngIf="isProductValidForFirstRow" style="width: 100%">
                      <div
                        class="header-height"
                        style="
                          width: 100%;
                          background: #142a49;
                          color: white;
                          border-top: 1px solid #ddd;
                        "
                      >
                        <label
                          class="headingFontSize"
                          style="margin-left: 15px; background-color: #142a49"
                        >
                          {{ lang.Pricing }}&nbsp;<i
                            class="bi bi-info-circle"
                          ></i>
                        </label>
                      </div>
                      <!-- Container to hold both questions in a row -->
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          flex-wrap: wrap;
                          gap: 20px;
                          padding: 10px 0;
                          padding-left: 15px;
                        "
                      >
                        <!-- Base Unit -->
                        <!-- Base Unit Value Dropdown -->
                        <!-- Question 1: Is Base Amount? -->
                        <div
                          style="display: flex; align-items: center; gap: 20px"
                        >
                          <!-- Is Base Amount? -->
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <label class="fontSize"
                              >Base Amount Applicable?</label
                            >

                            <div
                              style="
                                display: flex;
                                gap: 15px;
                                align-items: center;
                              "
                            >
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="isBaseAmount"
                                  [(ngModel)]="isBaseAmount"
                                  [value]="true"
                                  style="cursor: pointer"
                                />
                                Yes
                              </label>

                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="isBaseAmount"
                                  [(ngModel)]="isBaseAmount"
                                  [value]="false"
                                  style="cursor: pointer"
                                />
                                No
                              </label>
                            </div>
                          </div>

                          <!-- Base Unit Value Dropdown (visible only when true) -->
                          <div
                            *ngIf="isBaseAmount"
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                              min-width: 150px;
                            "
                          >
                            <ng-multiselect-dropdown
                              [placeholder]="'Select base unit'"
                              [settings]="{
                                singleSelection: true,
                                idField: 'id',
                                textField: 'value',
                                allowSearchFilter: false,
                                allowRemoteDataSearch: false,
                                enableCheckAll: false
                              }"
                              [data]="baseUnitValues"
                              [(ngModel)]="selectedBaseUnit"
                              (onSelect)="onSelectBaseUnit($event)"
                              (onDeSelect)="onDeselectonBaseUnit($event)"
                              [ngModelOptions]="{ standalone: true }"
                              style="font-size: 11px; min-width: 130px"
                            >
                            </ng-multiselect-dropdown>
                            <!--show other input for base unit  -->
                            <div
                              *ngIf="showOtherInputForBaseUnit"
                              style="flex: 1 1 13%; max-width: 120px"
                            >
                              <input
                                type="text"
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="otherInputForBaseUnit"
                                placeholder="Enter New Base Unit"
                                style="
                                  width: 100%;
                                  height: 30px;
                                  padding: 6px 10px;
                                  font-size: 14px;
                                  border: 1px solid #ccc;
                                  border-radius: 6px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                "
                                (input)="formatCurrency($event)"
                                (blur)="ensureDollar($event)"
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              />
                            </div>
                          </div>
                        </div>

                        <!-- Question 2 -->
                        <div
                          style="display: flex; align-items: center; gap: 20px"
                        >
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <label class="fontSize"
                              >Is price inclusive of tax?</label
                            >

                            <div
                              style="
                                display: flex;
                                gap: 15px;
                                align-items: center;
                              "
                            >
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="inclusiveTax"
                                  [(ngModel)]="inclusiveTax"
                                  [value]="true"
                                  style="cursor: pointer"
                                />
                                Yes
                              </label>

                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="inclusiveTax"
                                  [(ngModel)]="inclusiveTax"
                                  [value]="false"
                                  style="cursor: pointer"
                                />
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                        <!-- Question 1 -->
                        <div
                          style="display: flex; align-items: center; gap: 20px"
                        >
                          <!-- Are taxes applicable? -->
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <label class="fontSize">Is Tax Applicable?</label>

                            <div
                              style="
                                display: flex;
                                gap: 15px;
                                align-items: center;
                              "
                            >
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="taxApplicable"
                                  [(ngModel)]="taxApplicable"
                                  [value]="true"
                                  style="cursor: pointer"
                                />
                                Yes
                              </label>

                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="taxApplicable"
                                  [(ngModel)]="taxApplicable"
                                  [value]="false"
                                  style="cursor: pointer"
                                />
                                No
                              </label>
                            </div>
                          </div>

                          <!-- Tax Type checkboxes -->
                          <div
                            *ngIf="taxApplicable"
                            style="
                              display: flex;
                              align-items: center;
                              gap: 15px;
                            "
                          >
                            <label style="font-size: 14px">Tax Type</label>

                            <label
                              style="
                                display: flex;
                                align-items: center;
                                font-size: 13px;
                                gap: 5px;
                              "
                            >
                              <input
                                type="checkbox"
                                [(ngModel)]="taxTypes.hst"
                                style="cursor: pointer"
                              />
                              HST/GST
                            </label>

                            <label
                              style="
                                display: flex;
                                align-items: center;
                                font-size: 13px;
                                gap: 5px;
                              "
                            >
                              <input
                                type="checkbox"
                                [(ngModel)]="taxTypes.pst"
                                style="cursor: pointer"
                              />
                              PST
                            </label>
                          </div>
                        </div>
                      </div>

                      <!-- Three table  -->
                      <!-- *ngIf="
                        isProductValidForFirstRow &&
                        isProductValidForSecondRow &&
                        isProductValidForThirdRow &&
                        isProductValidForVendorAndPricing &&
                        isPricingSection
                      " -->
                      <div
                        class="pricing_section"
                        style="width: 100%; display: flex; column-gap: 10px"
                      >
                        <!-- Pricing  -->
                        <div
                          style="
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            text-align: center;
                          "
                        >
                          <!-- heading of Pricing Zones -->
                          <div
                            class="header-height"
                            style="
                              width: 100%;
                              background: #142a49;
                              color: white;
                              border-top: 1px solid #ddd;
                              /* border-radius: 6px 6px 0 0; */
                            "
                          >
                            <label
                              class="headingFontSize"
                              style="
                                margin-left: 15px;
                                background-color: #142a49;
                                text-align: center;
                              "
                            >
                              Pricing Zones
                            </label>
                          </div>
                          <!-- action and level input -->
                          <div
                            style="
                              width: 100%;
                              display: flex;
                              flex-direction: column;
                              padding: 5px;
                              padding-left: 15px;
                              align-items: flex-start;
                            "
                          >
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                gap: 20px;
                                min-width: 300px;
                                margin-top: 7px;
                              "
                            >
                              <label class="fontSize">No of Zones</label>
                              <!-- Levels Input -->
                              <input
                                type="number"
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="noOfPricingAreas"
                                (ngModelChange)="
                                  generatePricingAreaRows(noOfPricingAreas)
                                "
                                min="1"
                                max="10"
                                style="
                                  width: 40px;
                                  height: 25px;
                                  padding: 6px 10px;
                                  font-size: 14px;
                                  border: 1px solid #ccc;
                                  border-radius: 6px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              />
                            </div>

                            <!-- Table for pricing area -->
                            <!-- Scrollable container -->
                            <table
                              *ngIf="noOfPricingAreas > 0"
                              style="
                                font-weight: lighter;
                                width: 100%;
                                border-collapse: collapse;
                                font-family: Arial, sans-serif;
                                font-size: 12px;
                                table-layout: fixed;
                                border: 1px solid #b9b9b9;
                                margin-top: 19.5px;
                              "
                            >
                              <thead>
                                <tr
                                  style="
                                    background-color: #808285;
                                    color: white;
                                    height: 34px;
                                  "
                                >
                                  <th
                                    style="
                                      text-align: left;
                                      padding: 4px 6px;
                                      width: 15%;
                                      border-right: 1px solid #b9b9b9;
                                    "
                                  >
                                    Zone
                                  </th>
                                  <th
                                    style="
                                      text-align: left;
                                      padding: 4px 6px;
                                      width: 30%;
                                      border-right: 1px solid #b9b9b9;
                                    "
                                  >
                                    Name
                                  </th>
                                  <th
                                    style="
                                      text-align: left;
                                      padding: 4px 6px;
                                      width: 55%;
                                    "
                                  >
                                    Provinces
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                <tr
                                  *ngFor="
                                    let row of pricingAreaRows;
                                    let i = index
                                  "
                                  style="
                                    background-color: #f6f6f6;
                                    border-top: 1px solid #b9b9b9;
                                    border-bottom: 1px solid #b9b9b9;
                                    height: 34px;
                                  "
                                >
                                  <!-- Area -->
                                  <td
                                    style="
                                      text-align: left;
                                      padding: 3px 6px;
                                      border-right: 1px solid #b9b9b9;
                                      width: 15%;
                                    "
                                  >
                                    <input
                                      type="text"
                                      disabled
                                      [(ngModel)]="pricingAreaRows[i].area"
                                      style="
                                        width: 100%;
                                        border: none;
                                        outline: none;
                                        background: transparent;
                                        font-size: 13px;
                                      "
                                    />
                                  </td>

                                  <!-- Name -->
                                  <td
                                    style="
                                      text-align: left;
                                      padding: 3px 6px;
                                      border-right: 1px solid #b9b9b9;
                                      width: 30%;
                                    "
                                  >
                                    <input
                                      type="text"
                                      [(ngModel)]="pricingAreaRows[i].name"
                                      style="
                                        width: 100%;
                                        border: none;
                                        outline: none;
                                        background: transparent;
                                        font-size: 13px;
                                        text-transform: capitalize;
                                      "
                                    />
                                  </td>

                                  <!-- Select Areas -->
                                  <td
                                    style="
                                      text-align: left;
                                      padding: 3px 6px;
                                      width: 55%;
                                    "
                                  >
                                    <ng-multiselect-dropdown
                                      [placeholder]="'Select'"
                                      [settings]="
                                        pricingProvincesdropdownSettings
                                      "
                                      [data]="getAvailableProvinces(i)"
                                      [(ngModel)]="
                                        pricingAreaRows[i].selectedProvinces
                                      "
                                      (onSelect)="
                                        onPricingProvinceSelect($event, i)
                                      "
                                      (onDeSelect)="
                                        onPricingProvinceDeSelect($event, i)
                                      "
                                      [ngModel]="
                                        pricingAreaRows[i].selectedProvinces
                                      "
                                      style="font-size: 11px; min-height: 30px"
                                    >
                                    </ng-multiselect-dropdown>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <!-- Tiered Section -->
                        <div
                          style="
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            text-align: center;
                          "
                        >
                          <div
                            class="header-height"
                            style="
                              width: 100%;
                              background: #142a49;
                              color: white;
                              border-top: 1px solid #ddd;
                            "
                          >
                            <label
                              class="headingFontSize"
                              style="margin-left: 15px"
                              >Tiers/Age Bands</label
                            >
                          </div>

                          <!-- First Line: Tiers? and Age Bands? -->
                          <div
                            style="
                              display: flex;
                              justify-content: flex-start;
                              gap: 8px;
                              align-items: center;
                              margin-bottom: 10px;
                              margin-left: 10px;
                            "
                          >
                            <!-- Tiers -->
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                gap: 6px;
                              "
                            >
                              <label class="fontSize">Tiers?</label>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="tiered"
                                  [(ngModel)]="isTiered"
                                  (change)="onTierChange(true)"
                                  [value]="true"
                                  style="cursor: pointer"
                                />
                                Yes
                              </label>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="tiered"
                                  [(ngModel)]="isTiered"
                                  (change)="onTierChange(false)"
                                  [value]="false"
                                  style="cursor: pointer"
                                />
                                No
                              </label>
                            </div>

                            <!-- Age Bands -->
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                gap: 6px;
                              "
                            >
                              <label class="fontSize">Age Bands?</label>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="ageBands"
                                  [(ngModel)]="isAgeBanded"
                                  (change)="onAgeBandChange(true)"
                                  [value]="true"
                                  style="cursor: pointer"
                                />
                                Yes
                              </label>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  font-size: 13px;
                                  gap: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="ageBands"
                                  [(ngModel)]="isAgeBanded"
                                  (change)="onAgeBandChange(false)"
                                  [value]="false"
                                  style="cursor: pointer"
                                />
                                No
                              </label>
                            </div>
                          </div>

                          <!-- Second Line: Input fields appear if Yes is selected -->
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              margin-top: -5px;
                              margin-left: 10px;
                            "
                          >
                            <!-- No of Tiers -->
                            <div
                              *ngIf="isTiered"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                              "
                            >
                              <label style="font-size: 14px">No of Tiers</label>
                              <input
                                type="number"
                                [(ngModel)]="noOfTiered"
                                (ngModelChange)="generateTieredRows(noOfTiered)"
                                [ngModelOptions]="{ standalone: true }"
                                min="1"
                                max="10"
                                style="
                                  width: 40px;
                                  height: 25px;
                                  padding: 6px 10px;
                                  font-size: 14px;
                                  border: 1px solid #ccc;
                                  border-radius: 6px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              />
                            </div>

                            <!-- No of Age Bands -->
                            <div
                              *ngIf="isAgeBanded"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                              "
                            >
                              <label style="font-size: 14px"
                                >No of Age Bands</label
                              >
                              <input
                                type="number"
                                [(ngModel)]="noOfAgeBands"
                                (ngModelChange)="generateAgeBands(noOfAgeBands)"
                                [ngModelOptions]="{ standalone: true }"
                                min="1"
                                max="10"
                                style="
                                  width: 40px;
                                  height: 25px;
                                  padding: 6px 10px;
                                  font-size: 14px;
                                  border: 1px solid #ccc;
                                  border-radius: 6px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              />
                            </div>
                          </div>

                          <!-- Tier Table -->
                          <div
                            style="
                              padding-left: 10px;
                              padding-right: 5px;
                              padding-bottom: 2px;
                            "
                          >
                            <div
                              *ngIf="isTiered && noOfTiered > 0"
                              style="
                                width: 100%;
                                max-width: 800px;
                                margin-top: 5px;
                              "
                            >
                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 12px;
                                  border: 1px solid #ccc;
                                "
                              >
                                <thead
                                  style="background: #808285; color: white"
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 40%;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Tier
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 60%;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Tier Name
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="
                                      let row of tieredRows;
                                      let i = index
                                    "
                                  >
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      {{ i + 1 }}
                                    </td>
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        [(ngModel)]="tieredRows[i].name"
                                        style="
                                          text-align: center;
                                          width: 100%;
                                          padding: 2px 4px;
                                          font-size: 13px;
                                          border: none;
                                          outline: none;
                                          text-transform: capitalize;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                          <!-- Age Bands Table (Updated Styling to Match Tier Table) -->
                          <div
                            *ngIf="noOfAgeBands > 0"
                            style="
                              padding-left: 10px;
                              padding-right: 5px;
                              padding-bottom: 2px;
                            "
                          >
                            <div
                              style="
                                width: 100%;
                                max-width: 800px;
                                margin-top: 5px;
                              "
                            >
                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 12px;
                                  border: 1px solid #ccc;
                                "
                              >
                                <thead
                                  style="background: #808285; color: white"
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 33%;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Age Band
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 33%;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Start
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 34%;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      End
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="let row of ageBands; let i = index"
                                  >
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      {{ i + 1 }}
                                    </td>
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="number"
                                        [(ngModel)]="ageBands[i].start"
                                        [readonly]="i > 0"
                                        style="
                                          text-align: center;
                                          width: 100%;
                                          padding: 2px 4px;
                                          font-size: 13px;
                                          border: none;
                                          outline: none;
                                        "
                                      />
                                    </td>
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="number"
                                        [(ngModel)]="ageBands[i].end"
                                        (keyup)="onEndChange(i)"
                                        style="
                                          text-align: center;
                                          width: 100%;
                                          padding: 2px 4px;
                                          font-size: 13px;
                                          border: none;
                                          outline: none;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <!-- Variant Section -->
                        <div
                          style="
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            text-align: center;
                          "
                        >
                          <div
                            class="header-height"
                            style="
                              background: #142a49;
                              color: white;
                              border-top: 1px solid #ddd;
                            "
                          >
                            <label
                              class="headingFontSize"
                              style="margin-left: 15px"
                            >
                              Variants
                            </label>
                          </div>

                          <!-- Toggle and Input -->
                          <div
                            style="
                              width: 100%;
                              padding-left: 15px;
                              display: flex;
                              flex-direction: column;
                              gap: 5px;
                            "
                          >
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                              "
                            >
                              <label class="fontSize">Variants?</label>

                              <div
                                style="
                                  display: flex;
                                  gap: 15px;
                                  align-items: center;
                                "
                              >
                                <label
                                  style="
                                    display: flex;
                                    align-items: center;
                                    font-size: 13px;
                                    gap: 5px;
                                  "
                                >
                                  <input
                                    type="radio"
                                    name="variants"
                                    [(ngModel)]="isVariantEnabled"
                                    [value]="true"
                                    style="cursor: pointer"
                                  />
                                  Yes
                                </label>

                                <label
                                  style="
                                    display: flex;
                                    align-items: center;
                                    font-size: 13px;
                                    gap: 5px;
                                  "
                                >
                                  <input
                                    type="radio"
                                    name="variants"
                                    [(ngModel)]="isVariantEnabled"
                                    (change)="onVarientChange(false)"
                                    [value]="false"
                                    style="cursor: pointer"
                                  />
                                  No
                                </label>
                              </div>
                            </div>

                            <div
                              *ngIf="isVariantEnabled"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                              "
                            >
                              <label style="font-size: 14px"
                                >No of Variants</label
                              >
                              <input
                                type="number"
                                [(ngModel)]="noOfVariants"
                                (ngModelChange)="generateVariants(noOfVariants)"
                                [ngModelOptions]="{ standalone: true }"
                                min="1"
                                max="10"
                                style="
                                  width: 40px;
                                  height: 25px;
                                  padding: 6px 10px;
                                  font-size: 14px;
                                  border: 1px solid #ccc;
                                  border-radius: 6px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              />
                            </div>
                          </div>

                          <!-- Variant Table -->
                          <div style="padding-left: 15px; padding-right: 5px">
                            <div
                              *ngIf="isVariantEnabled && noOfVariants > 0"
                              style="
                                width: 100%;
                                max-width: 800px;
                                margin-top: 5px;
                              "
                            >
                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 12px;
                                  border: 1px solid #ccc;
                                "
                              >
                                <thead
                                  style="background: #808285; color: white"
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 40%;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Variant
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 60%;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Name
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="
                                      let row of variantRows;
                                      let i = index
                                    "
                                  >
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      {{ i + 1 }}
                                    </td>
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        [(ngModel)]="variantRows[i].name"
                                        style="
                                          text-align: center;
                                          width: 100%;
                                          padding: 2px 4px;
                                          font-size: 13px;
                                          border: none;
                                          outline: none;
                                          text-transform: capitalize;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>

                        <!-- Service Level Section -->
                        <div
                          style="
                            width: 100%;
                            display: flex;
                            flex-direction: column;
                            text-align: center;
                          "
                        >
                          <div
                            class="header-height"
                            style="
                              background: #142a49;
                              color: white;
                              border-top: 1px solid #ddd;
                            "
                          >
                            <label
                              class="headingFontSize"
                              style="margin-left: 15px"
                              >Service Level</label
                            >
                          </div>

                          <div
                            style="
                              width: 100%;
                              padding-left: 15px;
                              display: flex;
                              flex-direction: column;
                              gap: 5px;
                            "
                          >
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                              "
                            >
                              <label class="fontSize">Service Level?</label>

                              <div
                                style="
                                  display: flex;
                                  gap: 15px;
                                  align-items: center;
                                "
                              >
                                <label
                                  style="
                                    display: flex;
                                    align-items: center;
                                    font-size: 13px;
                                    gap: 5px;
                                  "
                                >
                                  <input
                                    type="radio"
                                    name="categories"
                                    [(ngModel)]="isCategory"
                                    style="cursor: pointer"
                                    [value]="true"
                                  />
                                  Yes
                                </label>

                                <label
                                  style="
                                    display: flex;
                                    align-items: center;
                                    font-size: 13px;
                                    gap: 5px;
                                  "
                                >
                                  <input
                                    type="radio"
                                    name="categories"
                                    [(ngModel)]="isCategory"
                                    (change)="onServiceLevelChange(false)"
                                    [value]="false"
                                    style="cursor: pointer"
                                  />
                                  No
                                </label>
                              </div>
                            </div>

                            <div
                              *ngIf="isCategory"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                              "
                            >
                              <label style="font-size: 14px"
                                >No of Levels</label
                              >
                              <input
                                type="number"
                                [(ngModel)]="noOfCategories"
                                (ngModelChange)="
                                  generateCategoryRows(noOfCategories)
                                "
                                [ngModelOptions]="{ standalone: true }"
                                min="1"
                                max="10"
                                style="
                                  width: 40px;
                                  height: 25px;
                                  padding: 6px 10px;
                                  font-size: 14px;
                                  border: 1px solid #ccc;
                                  border-radius: 6px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              />
                            </div>
                          </div>

                          <div style="padding-left: 15px; padding-right: 5px">
                            <div
                              *ngIf="isCategory && noOfCategories > 0"
                              style="
                                width: 100%;
                                max-width: 800px;
                                margin-top: 5px;
                              "
                            >
                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 12px;
                                  border: 1px solid #ccc;
                                "
                              >
                                <thead
                                  style="background: #808285; color: white"
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 40%;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Category
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        width: 60%;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      Category Name
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    *ngFor="
                                      let row of categoryRows;
                                      let i = index
                                    "
                                  >
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-right: 1px solid #ccc;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      {{ i + 1 }}
                                    </td>
                                    <td
                                      style="
                                        padding: 2px 4px;
                                        border-bottom: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        [(ngModel)]="categoryRows[i].name"
                                        style="
                                          text-align: center;
                                          width: 100%;
                                          padding: 2px 4px;
                                          font-size: 13px;
                                          border: none;
                                          outline: none;
                                          text-transform: capitalize;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Submit Data for showing tables -->
                      <!-- *ngIf="
                        isProductValidForFirstRow &&
                        isProductValidForSecondRow &&
                        isProductValidForThirdRow &&
                        isProductValidForVendorAndPricing &&
                        isPricingSection
                      " -->
                      <div style="width: 100%; margin-right: 2px; margin-bottom: 2px;">
  <!-- Errors -->
  <div *ngIf="errorsForTable.length > 0" class="error" style="text-align: right;">
    <div *ngFor="let err of errorsForTable">
      {{ err }}
    </div>
  </div>

  <!-- Button (aligned right) -->
  <div style="text-align: right; margin-top: 5px;">
    <button
      class="btn btn-sm fontSize"
      style="
        font-size: 14px;
        padding: 4px 12px;
        border-radius: 4px;
        background-color: #142a49;
        border: 1px solid #142a49;
        color: #ffffff;
        cursor: pointer;
      "
      (click)="showTable()"
    >
      Submit Pricing Data
    </button>
  </div>

  <!-- Info message (below button, right aligned) -->
  <div style="text-align: right; margin-top: 5px;">
    <span *ngIf="seeTable" class="fontSmallSize">
      <i class="bi bi-info-circle text-primary"></i> Scroll to See Pricing Table
    </span>
  </div>
</div>

                    </div>
                    <!-- BREAK LINE -->

                    <!-- Singup Form Section -->
                    <div *ngIf="isProductValidForFirstRow" style="width: 100%">
                      <div
                        class="header-height"
                        style="
                          width: 100%;
                          background: #142a49;
                          color: white;
                          border-top: 1px solid #ddd;
                        "
                      >
                        <label
                          class="headingFontSize"
                          style="margin-left: 15px; background-color: #142a49"
                        >
                          Signup Sheet&nbsp;<i class="bi bi-info-circle"></i>
                        </label>
                      </div>
                      <div
                        style="
                          padding-left: 15px;
                          display: flex;
                          flex-direction: column;
                          gap: 10px;
                          margin-top: 5px;
                        "
                      >
                        <!-- signup sheet manage -->
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            gap: 20px;
                            /* margin-bottom: 10px;
                          margin-top: 5px; */
                          "
                        >
                          <!-- Product Type Checkboxes -->
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <label
                              class="fontSize"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 5px;
                              "
                            >
                              <input
                                type="checkbox"
                                [(ngModel)]="targetsIndividual"
                                style="cursor: pointer"
                              />
                              Individual
                            </label>
                            <label
                              class="fontSize"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 5px;
                              "
                            >
                              <input
                                type="checkbox"
                                [(ngModel)]="targetsCorporate"
                                style="cursor: pointer"
                              />
                              Corporate
                            </label>
                          </div>

                          <!-- Group Plan Radio Buttons -->
                          <div
                            class="fontSize"
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <span class="fontSize">Group Plan?</span>
                            <label
                              style="
                                display: flex;
                                align-items: center;
                                gap: 5px;
                                font-size: 13px;
                                margin-right: 5px;
                              "
                            >
                              <input
                                type="radio"
                                name="groupPlan"
                                [(ngModel)]="isGroupPlan"
                                [value]="true"
                                style="cursor: pointer"
                              />
                              Yes
                            </label>
                            <label
                              style="
                                display: flex;
                                align-items: center;
                                gap: 5px;
                                font-size: 13px;
                              "
                            >
                              <input
                                type="radio"
                                name="groupPlan"
                                [(ngModel)]="isGroupPlan"
                                [value]="false"
                                style="cursor: pointer"
                              />
                              No
                            </label>
                          </div>

                          <!-- Min Headcount Input -->
                          <div
                            *ngIf="isGroupPlan"
                            style="
                              display: flex;
                              flex-direction: column;
                              gap: 2px;
                              width: 100px;
                            "
                          >
                            <input
                              type="text"
                              [(ngModel)]="minHeadcount"
                              min="1"
                              [ngModelOptions]="{ standalone: true }"
                              (keydown)="validateInteger($event)"
                              (paste)="validatePaste($event)"
                              placeholder="Min headcount"
                              style="
                                width: 1;
                                height: 30px;
                                padding: 6px 10px;
                                font-size: 14px;
                                border: 1px solid #ccc;
                                border-radius: 6px;
                                outline: none;
                                background-color: #e8eaf0;
                                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                transition: box-shadow 0.2s ease,
                                  border-color 0.2s ease;
                              "
                              onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                              onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                            />
                          </div>
                        </div>
                        <!-- dropdown for template -->
                        <div style="display: flex; column-gap: 10px">
                          <div style="max-width: 220px">
                            <label
                              class="fontSize"
                              style="margin-bottom: 4px; display: block"
                              >Select applicable signup template</label
                            >
                            <ng-multiselect-dropdown
                              [placeholder]="'Select template'"
                              [settings]="templateDropdownSettings"
                              [data]="signupTemplates"
                              [(ngModel)]="selectedTemplate"
                              (onSelect)="onTemplateSelect($event)"
                              style="
                                font-size: 13px;
                                outline: none;
                                background-color: #e8eaf0;
                                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                transition: box-shadow 0.2s ease,
                                  border-color 0.2s ease;
                                text-transform: capitalize;
                              "
                              onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                              onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                            >
                            </ng-multiselect-dropdown>
                          </div>
                          <p
                            *ngIf="numberOfFields"
                            style="
                              margin: 0;
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <span class="fontSize">
                              Selected Template :
                              <span class="fontSize" style="font-weight: 500">{{
                                selectedTemplate[0].text
                              }}</span>
                            </span>
                            <button
                              (click)="showPopups = true"
                              style="
                                background-color: #c87b00;
                                border: none;
                                border-radius: 6px;
                                cursor: pointer;
                                color: white;
                                padding: 2px 8px;
                                font-size: 12px;
                              "
                            >
                              <i class="bi bi-pencil-fill"></i>
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>

                    <!--Manage Signup Popup -->
                    <div
                      *ngIf="showPopups"
                      class="modal fade show d-block"
                      data-bs-backdrop="static"
                      tabindex="-1"
                      style="background: rgba(0, 0, 0, 0.5)"
                    >
                      <div
                        style="width: 50%; max-height: 400px; overflow-y: auto"
                        class="modal-dialog modal-lg modal-dialog-centered"
                      >
                        <div class="modal-content">
                          <!-- Header -->
                          <div
                            class="header-height"
                            style="
                              background-color: #5d7c9b;
                              display: flex;
                              justify-content: space-between;
                              align-items: center;
                              padding: 10px 15px;
                            "
                          >
                            <h6
                              class="fontSize"
                              style="
                                background-color: #5d7c9b;
                                color: white;
                                margin: 0;
                              "
                            >
                              Signup Form Fields :
                              <span class="fontSize" style="font-weight: 500">{{
                                selectedTemplate[0].text
                              }}</span>
                            </h6>
                            <button
                              (click)="onCancel()"
                              style="margin: 3px"
                              type="button"
                              class="btn-close"
                            ></button>
                          </div>

                          <!-- Body -->
                          <div style="padding: 15px">
                            <!-- Input Section -->
                            <div
                              style="
                                display: flex;
                                gap: 10px;
                                margin-bottom: 15px;
                              "
                            >
                              <div style="max-width: 160px">
                                <label class="fontSize">Field Name</label>
                                <input
                                  type="text"
                                  [ngModelOptions]="{ standalone: true }"
                                  [(ngModel)]="fieldName"
                                  placeholder="Field Name"
                                  style="
                                    width: 100%;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                    text-transform: capitalize;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                />
                              </div>
                              <div style="flex: 1 1 13%; min-width: 160px">
                                <label class="fontSize">Select Type</label>
                                <ng-multiselect-dropdown
                                  [placeholder]="'Select'"
                                  [settings]="countryDropdownSettings"
                                  [data]="fieldTypes"
                                  [(ngModel)]="signUpFieldType"
                                  style="
                                    font-size: 11px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                    text-transform: capitalize;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                >
                                </ng-multiselect-dropdown>
                              </div>
                              <div style="max-width: 160px">
                                <label class="fontSize">Field Rules</label>
                                <input
                                  type="text"
                                  [ngModelOptions]="{ standalone: true }"
                                  [(ngModel)]="fieldRules"
                                  placeholder="Field Name"
                                  style="
                                    width: 100%;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                    text-transform: capitalize;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                />
                              </div>
                              <button
                                class="btn btn-sm fontSize"
                                style="
                                  font-size: 14px;
                                  height: 30px;
                                  padding: 0 10px;
                                  border-radius: 4px;
                                  background-color: #142a49;
                                  border: 1px solid #142a49;
                                  color: #ffffff;
                                  cursor: pointer;
                                  margin-top: 23px;
                                "
                                (click)="addField()"
                              >
                                Add
                              </button>
                            </div>

                            <!-- List Section -->
                            <!-- List Section -->
                            <!-- List Section -->
                            <div
                              style="
                                max-height: 250px;
                                overflow-y: auto;
                                border: 1px solid #ddd;
                                padding: 10px;
                                border-radius: 4px;
                                margin-top: -5px; /* Closer to Add section */
                              "
                            >
                              <div
                                *ngFor="
                                  let field of tempForSignupSheet;
                                  let i = index
                                "
                                style="
                                  display: flex;
                                  gap: 10px;
                                  align-items: center;
                                  margin-bottom: 8px;
                                "
                              >
                                <!-- Checkbox -->
                                <input
                                  type="checkbox"
                                  [(ngModel)]="field.active"
                                />

                                <!-- Field Name -->
                                <div style="max-width: 160px">
                                  <input
                                    type="text"
                                    [ngModelOptions]="{ standalone: true }"
                                    [(ngModel)]="field.name"
                                    placeholder="Field Name"
                                    style="
                                      width: 100%;
                                      height: 30px;
                                      padding: 6px 10px;
                                      font-size: 14px;
                                      border: 1px solid #ccc;
                                      border-radius: 6px;
                                      outline: none;
                                      background-color: #e8eaf0;
                                    "
                                  />
                                </div>

                                <!-- Select Type -->
                                <div style="flex: 1 1 13%; min-width: 160px">
                                  <ng-multiselect-dropdown
                                    [placeholder]="'Select'"
                                    [settings]="countryDropdownSettings"
                                    [data]="fieldTypes"
                                    [(ngModel)]="field.type"
                                    style="
                                      font-size: 11px;
                                      background-color: #e8eaf0;
                                    "
                                  ></ng-multiselect-dropdown>
                                </div>

                                <!-- Field Rules -->
                                <div style="max-width: 160px">
                                  <input
                                    type="text"
                                    [ngModelOptions]="{ standalone: true }"
                                    [(ngModel)]="field.rules"
                                    placeholder="Field Rules"
                                    style="
                                      width: 100%;
                                      height: 30px;
                                      padding: 6px 10px;
                                      font-size: 14px;
                                      border: 1px solid #ccc;
                                      border-radius: 6px;
                                      outline: none;
                                      background-color: #e8eaf0;
                                    "
                                  />
                                </div>

                                <!-- Delete Button -->
                                <button
                                  (click)="deleteField(i)"
                                  style="
                                    background-color: #6b1004;
                                    border: none;
                                    border-radius: 6px;
                                    cursor: pointer;
                                    margin-top: 0;
                                    color: white;
                                    padding: 2px 8px;
                                    font-size: 12px;
                                  "
                                >
                                  <i class="bi bi-trash-fill"></i>
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Footer -->
                          <div
                            class="modal-footer"
                            style="
                              padding: 10px 15px;
                              justify-content: flex-end;
                              gap: 10px;
                            "
                          >
                            <!-- Reset -->
                            <button
                              *ngIf="selectedTemplate.text !== 'New template'"
                              class="btn btn-sm fontSize"
                              style="
                                font-size: 14px;
                                padding: 4px 12px;
                                border-radius: 4px;
                                background-color: white;
                                border: 1px solid #142a49;
                                color: #142a49;
                                cursor: pointer;
                              "
                              (click)="onReset()"
                            >
                              Reset
                            </button>
                            <!-- Cancel -->
                            <button
                              class="btn btn-sm fontSize"
                              style="
                                font-size: 14px;
                                padding: 4px 12px;
                                border-radius: 4px;
                                background-color: white;
                                border: 1px solid #142a49;
                                color: #142a49;
                                cursor: pointer;
                              "
                              (click)="onCancel()"
                            >
                              Cancel
                            </button>
                            <!--Save Product Button  -->
                            <button
                              *ngIf="tempForSignupSheet.length > 0"
                              class="btn btn-sm fontSize"
                              style="
                                font-size: 14px;
                                padding: 4px 12px;
                                border-radius: 4px;
                                background-color: #142a49;
                                color: white;
                                cursor: pointer;
                                border: 1px solid #142a49;
                              "
                              (click)="onSave()"
                            >
                              {{ replaceSaveName }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Provisioning and Reporting Section have to copy paste -->
                    <div *ngIf="isProductValidForFirstRow" style="width: 100%">
                      <div
                        class="header-height"
                        style="
                          width: 100%;
                          background: #142a49;
                          color: white;
                          border-top: 1px solid #ddd;
                        "
                      >
                        <label
                          class="headingFontSize"
                          style="margin-left: 15px; background-color: #142a49"
                        >
                          Provisioning And Reporting&nbsp;<i
                            class="bi bi-info-circle"
                          ></i>
                        </label>
                      </div>
                      <div style="padding-top: 5px; padding-left: 15px">
                        <div class="section-body">
                          <!-- Provisioning -->
                          <div style="display: flex; gap: 10px">
                            <div class="fontSize">Provisioning?</div>
                            <div
                              style="
                                display: flex;
                                gap: 10px;
                                align-items: center;
                              "
                            >
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 5px;
                                  font-size: 13px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="prov"
                                  [(ngModel)]="isProvisioning"
                                  [value]="true"
                                  [ngModelOptions]="{ standalone: true }"
                                />
                                Yes
                              </label>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 5px;
                                  font-size: 13px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="prov"
                                  [(ngModel)]="isProvisioning"
                                  [value]="false"
                                  [ngModelOptions]="{ standalone: true }"
                                />
                                No
                              </label>
                            </div>
                            <div
                              *ngIf="isProvisioning"
                              style="
                                display: flex;
                                align-items: center;
                                column-gap: 10px;
                              "
                            >
                              <div class="fontSize">Interfaces</div>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 5px;
                                "
                                class="radio-group"
                              >
                                <input
                                  type="checkbox"
                                  [(ngModel)]="useWebInterface"
                                  [ngModelOptions]="{ standalone: true }"
                                />
                                Web Interface
                              </label>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 5px;
                                "
                                class="radio-group"
                              >
                                <input
                                  type="checkbox"
                                  [(ngModel)]="useAPI"
                                  [ngModelOptions]="{ standalone: true }"
                                />
                                API
                              </label>
                            </div>
                          </div>

                          <div
                            *ngIf="isProvisioning"
                            class="sub-section"
                            style="
                              display: flex;
                              flex-direction: column;
                              row-gap: 5px;
                            "
                          >
                            <!-- Web Interface Block -->
                            <div *ngIf="useWebInterface" class="block">
                              <div class="row">
                                <div class="fontSize">Sandbox available?</div>
                                <div class="radio-group">
                                  <label
                                    ><input
                                      type="radio"
                                      name="sandbox"
                                      [(ngModel)]="hasSandbox"
                                      [value]="true"
                                      [ngModelOptions]="{ standalone: true }"
                                    />
                                    Yes</label
                                  >
                                  <label
                                    ><input
                                      type="radio"
                                      name="sandbox"
                                      [(ngModel)]="hasSandbox"
                                      [value]="false"
                                      [ngModelOptions]="{ standalone: true }"
                                    />
                                    No</label
                                  >
                                </div>
                              </div>
                              <!-- Sandbox Environment -->
                              <div
                                *ngIf="hasSandbox"
                                class="env-block"
                                style="
                                  margin-top: 8px;
                                  border-left: 4px solid #eef2f6;
                                  padding: 12px;
                                  display: grid;
                                  grid-template-columns: auto auto auto auto auto auto;
                                  gap: 12px;
                                  align-items: center;
                                "
                              >
                                <span class="fontSize" style="grid-column: 1/-1"
                                  >Sandbox</span
                                >

                                <input
                                  type="text"
                                  [(ngModel)]="sandbox.loginUrl"
                                  placeholder="Login URL"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 180px;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  "
                                />

                                <input
                                  type="text"
                                  [(ngModel)]="sandbox.username"
                                  placeholder="Username"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 180px;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  "
                                />

                                <input
                                  type="password"
                                  [(ngModel)]="sandbox.password"
                                  placeholder="Password"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 150px;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  "
                                />

                                <input
                                  type="text"
                                  [(ngModel)]="sandbox.provisioningUrl"
                                  placeholder="Provisioning URL"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 180px;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  "
                                />

                                <!-- 2FA Inline -->
                                <div
                                  style="
                                    display: inline-flex;
                                    align-items: center;
                                    gap: 8px;
                                  "
                                >
                                  <span style="font-size: 14px">2FA?</span>
                                  <label
                                    style="
                                      display: inline-flex;
                                      align-items: center;
                                      gap: 4px;
                                      cursor: pointer;
                                      font-size: 13px;
                                    "
                                  >
                                    <input
                                      type="radio"
                                      name="sandbox2fa"
                                      [(ngModel)]="sandbox.is2FA"
                                      [value]="true"
                                      [ngModelOptions]="{ standalone: true }"
                                      style="margin: 0"
                                    />
                                    Yes
                                  </label>
                                  <label
                                    style="
                                      display: inline-flex;
                                      align-items: center;
                                      gap: 4px;
                                      cursor: pointer;
                                      font-size: 13px;
                                    "
                                  >
                                    <input
                                      type="radio"
                                      name="sandbox2fa"
                                      [(ngModel)]="sandbox.is2FA"
                                      [value]="false"
                                      [ngModelOptions]="{ standalone: true }"
                                      style="margin: 0"
                                    />
                                    No
                                  </label>
                                </div>
                              </div>

                              <!-- Production Environment -->
                              <div
                                class="env-block"
                                style="
                                  margin-top: 8px;
                                  border-left: 4px solid #eef2f6;
                                  padding: 12px;
                                  display: grid;
                                  grid-template-columns: auto auto auto auto auto auto;
                                  gap: 12px;
                                  align-items: center;
                                "
                              >
                                <span class="fontSize" style="grid-column: 1/-1"
                                  >Production</span
                                >

                                <input
                                  type="text"
                                  [(ngModel)]="prod.loginUrl"
                                  placeholder="Login URL"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 180px;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  "
                                />

                                <input
                                  type="text"
                                  [(ngModel)]="prod.username"
                                  placeholder="Username"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 180px;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  "
                                />

                                <input
                                  type="password"
                                  [(ngModel)]="prod.password"
                                  placeholder="Password"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 150px;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  "
                                />

                                <input
                                  type="text"
                                  [(ngModel)]="prod.provisioningUrl"
                                  placeholder="Provisioning URL"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 180px;
                                    height: 30px;
                                    padding: 6px 10px;
                                    font-size: 14px;
                                    border: 1px solid #ccc;
                                    border-radius: 6px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  "
                                />

                                <!-- 2FA Inline -->
                                <div
                                  style="
                                    display: inline-flex;
                                    align-items: center;
                                    gap: 8px;
                                  "
                                >
                                  <span style="font-size: 14px">2FA?</span>
                                  <label
                                    style="
                                      display: inline-flex;
                                      align-items: center;
                                      gap: 4px;
                                      cursor: pointer;
                                      font-size: 13px;
                                    "
                                  >
                                    <input
                                      type="radio"
                                      name="prod2fa"
                                      [(ngModel)]="prod.is2FA"
                                      [value]="true"
                                      [ngModelOptions]="{ standalone: true }"
                                      style="margin: 0"
                                    />
                                    Yes
                                  </label>
                                  <label
                                    style="
                                      display: inline-flex;
                                      align-items: center;
                                      gap: 4px;
                                      cursor: pointer;
                                      font-size: 13px;
                                    "
                                  >
                                    <input
                                      type="radio"
                                      name="prod2fa"
                                      [(ngModel)]="prod.is2FA"
                                      [value]="false"
                                      [ngModelOptions]="{ standalone: true }"
                                      style="margin: 0"
                                    />
                                    No
                                  </label>
                                </div>
                              </div>

                              <!-- Special Fields for Web -->
                              <div class="special-fields">
                                <div
                                  style="
                                    display: flex;
                                    gap: 20px;
                                    align-items: center;
                                  "
                                >
                                  <span class="fontSize">
                                    Special Fields (Key / Value with condition)
                                  </span>
                                  <button
                                    type="button"
                                    class="btn btn-sm fontSize"
                                    style="
                                      font-size: 14px;
                                      padding: 4px 12px;
                                      border-radius: 4px;
                                      background-color: #142a49;
                                      border: 1px solid #142a49;
                                      color: #ffffff;
                                      border: none;
                                      cursor: pointer;
                                    "
                                    (click)="addFields('web')"
                                  >
                                    + Add Field
                                  </button>
                                </div>

                                <div
                                  *ngIf="webFields.length"
                                  style="
                                    width: 100%;
                                    max-width: 600px;
                                    margin-top: 5px;
                                  "
                                >
                                  <table
                                    style="
                                      width: 100%;
                                      border-collapse: collapse;
                                      font-size: 12px;
                                      border: 1px solid #ccc;
                                    "
                                  >
                                    <thead
                                      style="background: #808285; color: white"
                                    >
                                      <tr>
                                        <th
                                          style="
                                            padding: 6px;
                                            width: 40%;
                                            border-right: 1px solid #ccc;
                                            border-bottom: 1px solid #ccc;
                                            text-align: center;
                                          "
                                        >
                                          Key
                                        </th>
                                        <th
                                          style="
                                            padding: 6px;
                                            width: 50%;
                                            border-right: 1px solid #ccc;
                                            border-bottom: 1px solid #ccc;
                                            text-align: center;
                                          "
                                        >
                                          Value / Condition
                                        </th>
                                        <th
                                          style="
                                            padding: 6px;
                                            width: 10%;
                                            border-bottom: 1px solid #ccc;
                                          "
                                        >
                                          Action
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        *ngFor="
                                          let f of webFields;
                                          let i = index
                                        "
                                      >
                                        <td
                                          style="
                                            padding: 2px 4px;
                                            border-right: 1px solid #ccc;
                                            border-bottom: 1px solid #ccc;
                                          "
                                        >
                                          <input
                                            type="text"
                                            [(ngModel)]="f.key"
                                            placeholder="Key"
                                            [ngModelOptions]="{
                                              standalone: true
                                            }"
                                            style="
                                              text-align: center;
                                              width: 100%;
                                              padding: 2px 4px;
                                              font-size: 13px;
                                              border: none;
                                              outline: none;
                                            "
                                          />
                                        </td>
                                        <td
                                          style="
                                            padding: 2px 4px;
                                            border-right: 1px solid #ccc;
                                            border-bottom: 1px solid #ccc;
                                          "
                                        >
                                          <input
                                            type="text"
                                            [(ngModel)]="f.value"
                                            placeholder="Value / Condition"
                                            [ngModelOptions]="{
                                              standalone: true
                                            }"
                                            style="
                                              text-align: center;
                                              width: 100%;
                                              padding: 2px 4px;
                                              font-size: 13px;
                                              border: none;
                                              outline: none;
                                            "
                                          />
                                        </td>
                                        <td
                                          style="
                                            padding: 2px 4px;
                                            text-align: center;
                                            border-bottom: 1px solid #ccc;
                                          "
                                        >
                                          <span
                                            (click)="removeField('web', i)"
                                            style="
                                              cursor: pointer;
                                              color: #b22222;
                                            "
                                          >
                                            <i class="bi bi-trash-fill"></i>
                                          </span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            <!-- API Block -->
                            <div
                              *ngIf="useAPI"
                              class="block"
                              style="margin-top: 2px"
                            >
                              <input
                                type="text"
                                class="ref-input"
                                [(ngModel)]="apiKey"
                                placeholder="API Key"
                                [ngModelOptions]="{ standalone: true }"
                              />

                              <!-- HTML: API Parameters (keeps variables/functions/text names unchanged) -->
                              <!-- API Parameters -->
                              <div class="special-fields">
                                <div
                                  style="
                                    display: flex;
                                    gap: 20px;
                                    align-items: center;
                                  "
                                >
                                  <span class="fontSize">
                                    API Parameters (Key / Value with condition)
                                  </span>
                                  <button
                                    type="button"
                                    class="btn btn-sm fontSize"
                                    style="
                                      font-size: 14px;
                                      padding: 4px 12px;
                                      border-radius: 4px;
                                      background-color: #142a49;
                                      border: 1px solid #142a49;
                                      color: #ffffff;
                                      border: none;
                                      cursor: pointer;
                                    "
                                    (click)="addFields('api')"
                                  >
                                    + Add Field
                                  </button>
                                </div>

                                <div
                                  *ngIf="apiFields.length"
                                  style="
                                    width: 100%;
                                    max-width: 600px;
                                    margin-top: 5px;
                                  "
                                >
                                  <table
                                    style="
                                      width: 100%;
                                      border-collapse: collapse;
                                      font-size: 12px;
                                      border: 1px solid #ccc;
                                    "
                                  >
                                    <thead
                                      style="background: #808285; color: white"
                                    >
                                      <tr>
                                        <th
                                          style="
                                            padding: 6px;
                                            width: 40%;
                                            border-right: 1px solid #ccc;
                                            border-bottom: 1px solid #ccc;
                                            text-align: center;
                                          "
                                        >
                                          Key
                                        </th>
                                        <th
                                          style="
                                            padding: 6px;
                                            width: 50%;
                                            border-right: 1px solid #ccc;
                                            border-bottom: 1px solid #ccc;
                                            text-align: center;
                                          "
                                        >
                                          Value / Condition
                                        </th>
                                        <th
                                          style="
                                            padding: 6px;
                                            width: 10%;
                                            border-bottom: 1px solid #ccc;
                                          "
                                        >
                                          Action
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        *ngFor="
                                          let f of apiFields;
                                          let i = index
                                        "
                                      >
                                        <td
                                          style="
                                            padding: 2px 4px;
                                            border-right: 1px solid #ccc;
                                            border-bottom: 1px solid #ccc;
                                          "
                                        >
                                          <input
                                            type="text"
                                            [(ngModel)]="f.key"
                                            placeholder="Key"
                                            [ngModelOptions]="{
                                              standalone: true
                                            }"
                                            style="
                                              text-align: center;
                                              width: 100%;
                                              padding: 2px 4px;
                                              font-size: 13px;
                                              border: none;
                                              outline: none;
                                            "
                                          />
                                        </td>
                                        <td
                                          style="
                                            padding: 2px 4px;
                                            border-right: 1px solid #ccc;
                                            border-bottom: 1px solid #ccc;
                                          "
                                        >
                                          <input
                                            type="text"
                                            [(ngModel)]="f.value"
                                            placeholder="Value / Condition"
                                            [ngModelOptions]="{
                                              standalone: true
                                            }"
                                            style="
                                              text-align: center;
                                              width: 100%;
                                              padding: 2px 4px;
                                              font-size: 13px;
                                              border: none;
                                              outline: none;
                                            "
                                          />
                                        </td>
                                        <td
                                          style="
                                            padding: 2px 4px;
                                            text-align: center;
                                            border-bottom: 1px solid #ccc;
                                          "
                                        >
                                          <span
                                            (click)="removeField('api', i)"
                                            style="
                                              cursor: pointer;
                                              color: #b22222;
                                            "
                                          >
                                            <i class="bi bi-trash-fill"></i>
                                          </span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Reporting -->

                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <div
                              class="fontSize"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                              "
                            >
                              <span class="fontSize">Reporting?</span>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 5px;
                                  font-size: 13px;
                                  margin-right: 5px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="report"
                                  [(ngModel)]="isReporting"
                                  [value]="true"
                                  style="cursor: pointer"
                                />
                                Yes
                              </label>
                              <label
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 5px;
                                  font-size: 13px;
                                "
                              >
                                <input
                                  type="radio"
                                  name="report"
                                  [(ngModel)]="isReporting"
                                  [value]="false"
                                  style="cursor: pointer"
                                />
                                No
                              </label>
                            </div>
                            <!-- If Reporting -->
                            <ng-container *ngIf="isReporting">
                              <!-- File Type -->
                              <ng-multiselect-dropdown
                                [placeholder]="'File Type'"
                                [settings]="fileTypeDropdownSettings"
                                [data]="fileTypes"
                                [(ngModel)]="reportFileType"
                                [ngModelOptions]="{ standalone: true }"
                                style="
                                  width: 220px;
                                  font-size: 11px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                  text-transform: capitalize;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              >
                              </ng-multiselect-dropdown>

                              <!-- Frequency -->
                              <ng-multiselect-dropdown
                                [placeholder]="'Frequency'"
                                [settings]="frequencyDropdownSettings"
                                [data]="frequencies"
                                [(ngModel)]="reportFrequency"
                                [ngModelOptions]="{ standalone: true }"
                                style="
                                  width: 220px;
                                  font-size: 11px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                  text-transform: capitalize;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              >
                              </ng-multiselect-dropdown>

                              <!-- Due Date -->
                              <input
                                type="number"
                                [(ngModel)]="dueDate"
                                placeholder="Due day"
                                [ngModelOptions]="{ standalone: true }"
                                style="
                                  width: 100px;
                                  height: 30px;
                                  padding: 6px 10px;
                                  font-size: 14px;
                                  border: 1px solid #ccc;
                                  border-radius: 6px;
                                  outline: none;
                                  background-color: #e8eaf0;
                                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                  transition: box-shadow 0.2s ease,
                                    border-color 0.2s ease;
                                "
                                onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                              />

                              <!-- Self-billing -->
                              <label class="radio-group fontSize"
                                ><input
                                  type="checkbox"
                                  [(ngModel)]="isSelfBilling"
                                  [ngModelOptions]="{ standalone: true }"
                                />
                                Self-billing</label
                              >

                              <!-- Census -->
                              <label class="radio-group fontSize"
                                ><input
                                  type="checkbox"
                                  [(ngModel)]="isCensus"
                                  [ngModelOptions]="{ standalone: true }"
                                />
                                Census</label
                              >
                            </ng-container>
                          </div>

                          <div *ngIf="isReporting" class="sub-section">
                            <!-- Self Billing -->
                            <div *ngIf="isSelfBilling" class="block">
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 15px;
                                  margin-bottom: 8px;
                                "
                              >
                                <div
                                  style="
                                    min-width: 130px;
                                    font-weight: 500;
                                    font-size: 13px;
                                  "
                                >
                                  Reporting Period
                                </div>
                                <!-- Start Month -->
                                <ng-multiselect-dropdown
                                  [placeholder]="'Start Month'"
                                  [settings]="{
                                    singleSelection: true,
                                    allowSearchFilter: false,
                                    closeDropDownOnSelection: true,
                                    textField: 'name',
                                    idField: 'id',
                                    maxHeight: 200
                                  }"
                                  [data]="months"
                                  [(ngModel)]="startMonth"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 220px;
                                    font-size: 11px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                    text-transform: capitalize;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                >
                                </ng-multiselect-dropdown>

                                <!-- End Month -->
                                <ng-multiselect-dropdown
                                  [placeholder]="'End Month'"
                                  [settings]="{
                                    singleSelection: true,
                                    allowSearchFilter: false,
                                    closeDropDownOnSelection: true,
                                    textField: 'name',
                                    idField: 'id',
                                    maxHeight: 200
                                  }"
                                  [data]="months"
                                  [(ngModel)]="endMonth"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 220px;
                                    font-size: 11px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                    text-transform: capitalize;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                >
                                </ng-multiselect-dropdown>
                              </div>

                              <!-- Self-billing Fields -->
                              <div
                                style="
                                  display: flex;
                                  align-items: flex-start;
                                  gap: 20px;
                                  width: 100%;
                                "
                              >
                                <div class="special-fields" style="width: 40%">
                                  <div
                                    style="
                                      display: flex;
                                      gap: 20px;
                                      align-items: center;
                                    "
                                  >
                                    <span class="fontSize">
                                      Self-billing Fields (Key / Value with
                                      condition)
                                    </span>
                                    <button
                                      type="button"
                                      class="btn btn-sm fontSize"
                                      style="
                                        font-size: 14px;
                                        padding: 4px 12px;
                                        border-radius: 4px;
                                        background-color: #142a49;
                                        border: 1px solid #142a49;
                                        color: #ffffff;
                                        border: none;
                                        cursor: pointer;
                                      "
                                      (click)="addFields('self')"
                                    >
                                      + Add Field
                                    </button>
                                  </div>

                                  <div
                                    *ngIf="selfFields.length"
                                    style="
                                      width: 100%;
                                      max-width: 600px;
                                      margin-top: 5px;
                                    "
                                  >
                                    <table
                                      style="
                                        width: 100%;
                                        border-collapse: collapse;
                                        font-size: 12px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <thead
                                        style="
                                          background: #808285;
                                          color: white;
                                        "
                                      >
                                        <tr>
                                          <th
                                            style="
                                              padding: 6px;
                                              width: 40%;
                                              border-right: 1px solid #ccc;
                                              border-bottom: 1px solid #ccc;
                                              text-align: center;
                                            "
                                          >
                                            Key
                                          </th>
                                          <th
                                            style="
                                              padding: 6px;
                                              width: 50%;
                                              border-right: 1px solid #ccc;
                                              border-bottom: 1px solid #ccc;
                                              text-align: center;
                                            "
                                          >
                                            Value / Condition
                                          </th>
                                          <th
                                            style="
                                              padding: 6px;
                                              width: 10%;
                                              border-bottom: 1px solid #ccc;
                                            "
                                          >
                                            Action
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          *ngFor="
                                            let f of selfFields;
                                            let i = index
                                          "
                                        >
                                          <td
                                            style="
                                              padding: 2px 4px;
                                              border-right: 1px solid #ccc;
                                              border-bottom: 1px solid #ccc;
                                            "
                                          >
                                            <input
                                              type="text"
                                              [(ngModel)]="f.key"
                                              placeholder="Key"
                                              [ngModelOptions]="{
                                                standalone: true
                                              }"
                                              style="
                                                text-align: center;
                                                width: 100%;
                                                padding: 2px 4px;
                                                font-size: 13px;
                                                border: none;
                                                outline: none;
                                              "
                                            />
                                          </td>
                                          <td
                                            style="
                                              padding: 2px 4px;
                                              border-right: 1px solid #ccc;
                                              border-bottom: 1px solid #ccc;
                                            "
                                          >
                                            <input
                                              type="text"
                                              [(ngModel)]="f.value"
                                              placeholder="Value / Condition"
                                              [ngModelOptions]="{
                                                standalone: true
                                              }"
                                              style="
                                                text-align: center;
                                                width: 100%;
                                                padding: 2px 4px;
                                                font-size: 13px;
                                                border: none;
                                                outline: none;
                                              "
                                            />
                                          </td>
                                          <td
                                            style="
                                              padding: 2px 4px;
                                              text-align: center;
                                              border-bottom: 1px solid #ccc;
                                            "
                                          >
                                            <span
                                              (click)="removeField('self', i)"
                                              style="
                                                cursor: pointer;
                                                color: #b22222;
                                              "
                                            >
                                              <i class="bi bi-trash-fill"></i>
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <!-- Divider -->
                                <div
                                  style="
                                    width: 1px;
                                    background-color: #ccc;
                                    box-shadow: 1px 0 3px rgba(0, 0, 0, 0.1);
                                  "
                                ></div>
                                <!-- Census Fields -->
                                <div
                                  *ngIf="isCensus"
                                  class="special-fields"
                                  style="width: 40%"
                                >
                                  <div
                                    style="
                                      display: flex;
                                      gap: 20px;
                                      align-items: center;
                                    "
                                  >
                                    <span class="fontSize">
                                      Census Fields (Key / Value with condition)
                                    </span>
                                    <button
                                      type="button"
                                      class="btn btn-sm fontSize"
                                      style="
                                        font-size: 14px;
                                        padding: 4px 12px;
                                        border-radius: 4px;
                                        background-color: #142a49;
                                        border: 1px solid #142a49;
                                        color: #ffffff;
                                        border: none;
                                        cursor: pointer;
                                      "
                                      (click)="addFields('census')"
                                    >
                                      + Add Field
                                    </button>
                                  </div>

                                  <div
                                    *ngIf="censusFields.length"
                                    style="
                                      width: 100%;
                                      max-width: 600px;
                                      margin-top: 5px;
                                    "
                                  >
                                    <table
                                      style="
                                        width: 100%;
                                        border-collapse: collapse;
                                        font-size: 12px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <thead
                                        style="
                                          background: #808285;
                                          color: white;
                                        "
                                      >
                                        <tr>
                                          <th
                                            style="
                                              padding: 6px;
                                              width: 40%;
                                              border-right: 1px solid #ccc;
                                              border-bottom: 1px solid #ccc;
                                              text-align: center;
                                            "
                                          >
                                            Key
                                          </th>
                                          <th
                                            style="
                                              padding: 6px;
                                              width: 50%;
                                              border-right: 1px solid #ccc;
                                              border-bottom: 1px solid #ccc;
                                              text-align: center;
                                            "
                                          >
                                            Value / Condition
                                          </th>
                                          <th
                                            style="
                                              padding: 6px;
                                              width: 10%;
                                              border-bottom: 1px solid #ccc;
                                            "
                                          >
                                            Action
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr
                                          *ngFor="
                                            let f of censusFields;
                                            let i = index
                                          "
                                        >
                                          <td
                                            style="
                                              padding: 2px 4px;
                                              border-right: 1px solid #ccc;
                                              border-bottom: 1px solid #ccc;
                                            "
                                          >
                                            <input
                                              type="text"
                                              [(ngModel)]="f.key"
                                              placeholder="Key"
                                              [ngModelOptions]="{
                                                standalone: true
                                              }"
                                              style="
                                                text-align: center;
                                                width: 100%;
                                                padding: 2px 4px;
                                                font-size: 13px;
                                                border: none;
                                                outline: none;
                                              "
                                            />
                                          </td>
                                          <td
                                            style="
                                              padding: 2px 4px;
                                              border-right: 1px solid #ccc;
                                              border-bottom: 1px solid #ccc;
                                            "
                                          >
                                            <input
                                              type="text"
                                              [(ngModel)]="f.value"
                                              placeholder="Value / Condition"
                                              [ngModelOptions]="{
                                                standalone: true
                                              }"
                                              style="
                                                text-align: center;
                                                width: 100%;
                                                padding: 2px 4px;
                                                font-size: 13px;
                                                border: none;
                                                outline: none;
                                              "
                                            />
                                          </td>
                                          <td
                                            style="
                                              padding: 2px 4px;
                                              text-align: center;
                                              border-bottom: 1px solid #ccc;
                                            "
                                          >
                                            <span
                                              (click)="removeField('census', i)"
                                              style="
                                                cursor: pointer;
                                                color: #b22222;
                                              "
                                            >
                                              <i class="bi bi-trash-fill"></i>
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Both Self-billing and Census -->
                            <div
                              *ngIf="isSelfBilling && isCensus"
                              class="block"
                              style="display: flex"
                            >
                              <div class="row">
                                <label class="fontSize">
                                  Combine into single file?
                                </label>
                                <div class="radio-group">
                                  <label
                                    ><input
                                      type="radio"
                                      name="combine"
                                      [(ngModel)]="combineReports"
                                      [value]="true"
                                      [ngModelOptions]="{ standalone: true }"
                                    />
                                    Yes</label
                                  >
                                  <label
                                    ><input
                                      type="radio"
                                      name="combine"
                                      [(ngModel)]="combineReports"
                                      [value]="false"
                                      [ngModelOptions]="{ standalone: true }"
                                    />
                                    No</label
                                  >
                                </div>
                              </div>

                              <div class="row">
                                <label class="fontSize">
                                  Maintain Census History?
                                </label>
                                <div class="radio-group">
                                  <label
                                    ><input
                                      type="radio"
                                      name="history"
                                      [(ngModel)]="maintainHistory"
                                      [value]="true"
                                      [ngModelOptions]="{ standalone: true }"
                                    />
                                    Yes</label
                                  >
                                  <label
                                    ><input
                                      type="radio"
                                      name="history"
                                      [(ngModel)]="maintainHistory"
                                      [value]="false"
                                      [ngModelOptions]="{ standalone: true }"
                                    />
                                    No</label
                                  >
                                </div>
                              </div>
                              <div>
                                <label class="fontSize"
                                  >Compile vs Separate?</label
                                >
                                <ng-multiselect-dropdown
                                  [placeholder]="'Select Mode'"
                                  [settings]="{
                                    singleSelection: true,
                                    allowSearchFilter: false,
                                    closeDropDownOnSelection: true,
                                    textField: 'name',
                                    idField: 'id',
                                    maxHeight: 200
                                  }"
                                  [data]="[
                                    { id: 'compile', name: 'Compile' },
                                    { id: 'separate', name: 'Separate' }
                                  ]"
                                  [(ngModel)]="compileMode"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    font-size: 11px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                    text-transform: capitalize;
                                  "
                                  onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                                  onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                                >
                                </ng-multiselect-dropdown>
                              </div>
                            </div>

                            <!-- Delivery -->
                            <div
                              class="block"
                              style="
                                display: flex;
                                align-items: center;
                                gap: 10px;
                                flex-wrap: nowrap;
                              "
                            >
                              <!-- Delivery Method Dropdown -->
                              <div
                                style="
                                  display: flex;
                                  align-items: center;
                                  gap: 10px;
                                "
                              >
                                <div class="fontSize">Delivery Method</div>
                                <ng-multiselect-dropdown
                                  [placeholder]="'Select Delivery Method'"
                                  [settings]="{
                                    singleSelection: true,
                                    allowSearchFilter: false,
                                    closeDropDownOnSelection: true,
                                    textField: 'name',
                                    idField: 'id',
                                    maxHeight: 200
                                  }"
                                  [data]="[
                                    { id: 'email', name: 'Email' },
                                    { id: 'sftp', name: 'SFTP / Website' }
                                  ]"
                                  [(ngModel)]="deliveryMethod"
                                  [ngModelOptions]="{ standalone: true }"
                                  style="
                                    width: 200px;
                                    font-size: 11px;
                                    outline: none;
                                    background-color: #e8eaf0;
                                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                                    transition: box-shadow 0.2s ease,
                                      border-color 0.2s ease;
                                    text-transform: capitalize;
                                  "
                                  (focus)="
                                    this.style.boxShadow =
                                      '0 2px 6px rgba(0,0,0,0.12)';
                                    this.style.borderColor = '#6c757d'
                                  "
                                  (blur)="
                                    this.style.boxShadow =
                                      '0 1px 3px rgba(0,0,0,0.08)';
                                    this.style.borderColor = '#ccc'
                                  "
                                ></ng-multiselect-dropdown>
                              </div>

                              <!-- Email Input -->
                              <input
                                *ngIf="
                                  deliveryMethod &&
                                  deliveryMethod.length &&
                                  deliveryMethod[0].name === 'Email'
                                "
                                class="ref-input"
                                type="text"
                                [(ngModel)]="emailRecipients"
                                placeholder="Recipients (comma separated)"
                                [ngModelOptions]="{ standalone: true }"
                                style="width: 250px; font-size: 11px"
                              />

                              <!-- SFTP Inputs -->
                              <input
                                *ngIf="
                                  deliveryMethod &&
                                  deliveryMethod.length &&
                                  deliveryMethod[0].name === 'SFTP / Website'
                                "
                                class="ref-input"
                                type="text"
                                [(ngModel)]="sftpHost"
                                placeholder="SFTP Host"
                                [ngModelOptions]="{ standalone: true }"
                                style="width: 150px; font-size: 11px"
                              />
                              <input
                                *ngIf="
                                  deliveryMethod &&
                                  deliveryMethod.length &&
                                  deliveryMethod[0].name === 'SFTP / Website'
                                "
                                class="ref-input"
                                type="text"
                                [(ngModel)]="sftpPath"
                                placeholder="Path"
                                [ngModelOptions]="{ standalone: true }"
                                style="width: 150px; font-size: 11px"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--Product Resource Description Editor Quill editor -->
                    <div
                      *ngIf="showProduct_Resource_QuillEditor"
                      class="modal fade show d-block"
                      data-bs-backdrop="static"
                      tabindex="-1"
                      style="background: rgba(0, 0, 0, 0.5)"
                    >
                      <div
                        style="width: 40%"
                        class="modal-dialog modal-lg modal-dialog-centered"
                      >
                        <div class="modal-content">
                          <!-- Header -->
                          <div
                            class="header-height"
                            style="
                              background-color: #5d7c9b;
                              display: flex;
                              justify-content: space-between;
                              align-items: center;
                              padding: 10px 15px;
                            "
                          >
                            <h6
                              class="fontSize"
                              style="
                                color: white;
                                margin: 0;
                                background-color: #5d7c9b;
                              "
                            >
                              Product Resource Description
                            </h6>
                            <button
                              (click)="onCanceloOfProductResourceDescription()"
                              style="margin: 3px"
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>

                          <!-- Body -->
                          <div class="modal-body" style="padding: 10px">
                            <quill-editor
                              [(ngModel)]="editorContentForProductResource"
                              [modules]="quillModulesForProductResource"
                              [styles]="{ height: '250px' }"
                              placeholder="Start writing here..."
                            >
                            </quill-editor>
                          </div>

                          <!-- Footer -->
                          <div
                            class="modal-footer"
                            style="
                              padding: 10px 15px;
                              justify-content: flex-end;
                              gap: 10px;
                            "
                          >
                            <button
                              style="
                                padding: 6px 20px;
                                background-color: white;
                                border: 1px solid #142a49;
                                border-radius: 10px;
                                color: black;
                                font-size: 14px;
                                font-weight: 500;
                                cursor: pointer;
                              "
                              (click)="onCanceloOfProductResourceDescription()"
                            >
                              Cancel
                            </button>

                            <button
                              style="
                                padding: 6px 20px;
                                background-color: #142a49;
                                border: 1px solid #4883f2;
                                border-radius: 10px;
                                color: white;
                                font-size: 14px;
                                font-weight: 500;
                                cursor: pointer;
                              "
                              (click)="onProductResourceFileSave()"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--Tile Description Editor Quill editor -->
                    <div
                      *ngIf="showTileQuillEditor"
                      class="modal fade show d-block"
                      data-bs-backdrop="static"
                      tabindex="-1"
                      style="background: rgba(0, 0, 0, 0.5)"
                    >
                      <div
                        style="width: 40%"
                        class="modal-dialog modal-lg modal-dialog-centered"
                      >
                        <div class="modal-content">
                          <!-- Header -->
                          <div
                            class="header-height"
                            style="
                              background-color: #5d7c9b;
                              display: flex;
                              justify-content: space-between;
                              align-items: center;
                              padding: 10px 15px;
                            "
                          >
                            <h6
                              class="fontSize"
                              style="
                                color: white;
                                margin: 0;
                                background-color: #5d7c9b;
                              "
                            >
                              Tile Description Editor
                            </h6>
                            <button
                              (click)="onCanceloOfTileDescription()"
                              style="margin: 3px"
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>

                          <!-- Body -->
                          <div class="modal-body" style="padding: 10px">
                            <quill-editor
                              [(ngModel)]="editorContent"
                              [modules]="quillModulesForTileDescription"
                              [styles]="{ height: '250px' }"
                              placeholder="Start writing here..."
                            >
                            </quill-editor>
                            <div
                              style="
                                position: relative;
                                width: 40%;
                                height: 34px;
                              "
                            >
                              <!-- Hidden File Input -->
                              <input
                                #fileInput
                                type="file"
                                accept="image/*"
                                id="ToolkitUpload"
                                (change)="handleTileLogo($event)"
                                hidden
                              />
                              <!-- Styled Button -->
                              <button
                                for="ToolkitUpload"
                                (click)="fileInput.click()"
                                class="btn btn-sm fontSize"
                                style="
                                  margin-top: 2px;
                                  font-size: 14px;
                                  padding: 4px 12px;
                                  border-radius: 4px;
                                  background-color: white;
                                  border: 1px solid #142a49;
                                  color: #142a49;
                                  cursor: pointer;
                                "
                              >
                                Choose Logo
                              </button>
                              <!-- Logo Error -->
                              <div
                                *ngIf="!previewTileLogoUrl && tileError"
                                style="color: red; font-size: 13px"
                              >
                                Please choose logo
                              </div>
                            </div>
                          </div>
                          <img
                            *ngIf="previewTileLogoUrl"
                            [src]="previewTileLogoUrl"
                            alt="Preview"
                            style="
                              max-width: 200px;
                              margin-top: 3px;
                              margin-left: 10px;
                              border: 1px solid #ccc;
                            "
                          />
                          <!-- Footer -->
                          <div
                            class="modal-footer"
                            style="
                              padding: 10px 15px;
                              justify-content: flex-end;
                              gap: 10px;
                            "
                          >
                            <button
                              style="
                                padding: 6px 20px;
                                background-color: white;
                                border: 1px solid #142a49;
                                border-radius: 10px;
                                color: black;
                                font-size: 14px;
                                font-weight: 500;
                                cursor: pointer;
                              "
                              (click)="onCanceloOfTileDescription()"
                            >
                              Cancel
                            </button>

                            <button
                              style="
                                padding: 6px 20px;
                                background-color: #142a49;
                                border: 1px solid #4883f2;
                                border-radius: 10px;
                                color: white;
                                font-size: 14px;
                                font-weight: 500;
                                cursor: pointer;
                              "
                              (click)="onTileFileSave()"
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- quill view Tile Description-->
                    <!-- Preview Popup with Quill content -->
                    <div
                      *ngIf="previewQuillEditor"
                      class="popup-wrapper"
                      style="
                        position: fixed;
                        top: 0;
                        left: 0;
                        z-index: 1000;
                        width: 100%;
                        height: 100%;
                        background: rgba(0, 0, 0, 0.4);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <div
                        class="popup-content"
                        style="
                          background: white;
                          width: fit-content;
                          min-width: 420px;
                          height: auto;
                          display: flex;
                          flex-direction: column;
                          justify-content: space-between;
                          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
                        "
                      >
                        <!-- Title Bar -->
                        <div
                          class="header-height"
                          style="
                            background-color: #5d7c9b;
                            color: white;
                            font-weight: 500;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                          "
                        >
                          <span class="fontSize" style="margin-left: 10px"
                            >Tile Description Preview</span
                          >
                          <button
                            (click)="onClosePopup()"
                            style="margin: 3px"
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>

                        <!-- Preview Body -->
                        <div
                          style="
                            flex-grow: 1;
                            padding: 20px;
                            overflow-y: auto;
                            max-height: 80vh;
                          "
                        >
                          <div
                            style="
                              width: 400px;
                              background-color: #fff0f5;
                              border-radius: 10px;
                              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
                            "
                          >
                            <!-- Default image -->
                            <div style="width: 100%; text-align: center">
                              <img
                                id="image"
                                *ngIf="previewTileLogoUrl"
                                [src]="previewTileLogoUrl"
                                style="
                                  border-top-left-radius: 6px;
                                  border-top-right-radius: 6px;
                                "
                                width="100%"
                              />
                            </div>

                            <!-- Rendered Quill content -->
                            <div
                              style="margin-top: -5px"
                              class="ql-editor"
                              [innerHTML]="safeHtmlContent"
                            ></div>
                          </div>
                        </div>

                        <!-- Footer -->
                        <div
                          style="
                            padding: 10px 16px;
                            display: flex;
                            justify-content: flex-end;
                            gap: 10px;
                          "
                        >
                          <button
                            style="
                              padding: 6px 20px;
                              background-color: white;
                              border: 1px solid #142a49;
                              border-radius: 10px;
                              color: black;
                              font-size: 14px;
                              font-weight: 500;
                              cursor: pointer;
                            "
                            (click)="onClosePopup()"
                          >
                            Done
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Preview Popup with Product Description Quill content -->
                    <div
                      *ngIf="previewProduct_Resource_QuillEditor"
                      class="popup-wrapper"
                      style="
                        position: fixed;
                        top: 0;
                        left: 0;
                        z-index: 1000;
                        width: 100%;
                        height: 100%;
                        background: rgba(0, 0, 0, 0.4);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <div
                        class="popup-content"
                        style="
                          background: white;
                          width: fit-content;
                          min-width: 420px;
                          height: auto;
                          display: flex;
                          flex-direction: column;
                          justify-content: space-between;
                          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
                        "
                      >
                        <!-- Title Bar -->
                        <div
                          class="header-height"
                          style="
                            background-color: #5d7c9b;
                            color: white;
                            font-weight: 500;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                          "
                        >
                          <span class="fontSize" style="margin-left: 10px"
                            >Product Description Preview</span
                          >
                          <button
                            (click)="onProductPreviewClosePopup()"
                            style="margin: 3px"
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>

                        <!-- Preview Body -->
                        <div
                          style="
                            flex-grow: 1;
                            padding: 20px;
                            overflow-y: auto;
                            max-height: 80vh;
                          "
                        >
                          <div
                            style="
                              width: 400px;
                              background-color: #fff0f5;
                              border-radius: 10px;
                              box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
                            "
                          >
                            <!-- Default image -->
                            <div style="width: 100%; text-align: center">
                              <img
                                id="image"
                                style="
                                  border-top-left-radius: 6px;
                                  border-top-right-radius: 6px;
                                "
                                src="../../../assets/img/dependent_illness.png"
                                width="100%"
                              />
                            </div>

                            <!-- Rendered Quill content -->
                            <div
                              style="margin-top: -5px"
                              class="ql-editor"
                              [innerHTML]="safeHtmlContentForProduct_Resource"
                            ></div>
                          </div>
                        </div>

                        <!-- Footer -->
                        <div
                          style="
                            padding: 10px 16px;
                            display: flex;
                            justify-content: flex-end;
                            gap: 10px;
                          "
                        >
                          <button
                            style="
                              padding: 6px 20px;
                              background-color: white;
                              border: 1px solid #142a49;
                              border-radius: 10px;
                              color: black;
                              font-size: 14px;
                              font-weight: 500;
                              cursor: pointer;
                            "
                            (click)="onProductPreviewClosePopup()"
                          >
                            Done
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- heading of Pricing Data -->
                    <!-- <div *ngIf="billingType" style="width: 100%"> -->
                    <div *ngIf="showPricingTable" style="width: 100%">
                      <!-- heading of Pricing Data -->
                      <div
                        class="header-height"
                        style="
                          width: 100%;
                          background: #142a49;
                          color: white;
                          border-top: 1px solid #ddd;
                        "
                      >
                        <label
                          class="headingFontSize"
                          style="
                            margin: 0;
                            background-color: #142a49;
                            text-align: center;
                            padding-left: 15px;
                          "
                        >
                          Pricing Data&nbsp;<i class="bi bi-info-circle"></i>
                        </label>
                      </div>
                      <!-- Advisor Comission and TPA Comission and other fees -->
                      <div
                        *ngIf="isProductValidForFirstRow"
                        style="
                          padding-left: 15px;
                          display: flex;
                          align-items: center;
                          flex-wrap: wrap;
                          gap: 12px;
                        "
                      >
                        <!-- Advisor Commission -->
                        <div style="max-width: 160px">
                          <label class="fontSize">Advisor Commission</label>
                          <input
                            type="number"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="advisorCommission"
                            placeholder="Advisor Commission"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <label>
                              <input
                                type="radio"
                                name="advisorType"
                                value="$"
                                [(ngModel)]="advisorCommissionType"
                              />
                              $
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="advisorType"
                                value="%"
                                [(ngModel)]="advisorCommissionType"
                              />
                              %
                            </label>
                          </div>
                        </div>

                        <!-- TPA Commission -->
                        <div style="max-width: 160px">
                          <label class="fontSize">TPA Commission</label>
                          <input
                            type="number"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="tpaCommission"
                            placeholder="TPA Commission"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <label>
                              <input
                                type="radio"
                                name="tpaType"
                                value="$"
                                [(ngModel)]="tpaCommissionType"
                              />
                              $
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="tpaType"
                                value="%"
                                [(ngModel)]="tpaCommissionType"
                              />
                              %
                            </label>
                          </div>
                        </div>

                        <!-- Other Fees -->
                        <div style="max-width: 160px">
                          <label class="fontSize">Other Fees</label>
                          <input
                            type="number"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="otherFees"
                            placeholder="Other Fees"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <label>
                              <input
                                type="radio"
                                name="otherFeesType"
                                value="$"
                                [(ngModel)]="otherFeesType"
                              />
                              $
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="otherFeesType"
                                value="%"
                                [(ngModel)]="otherFeesType"
                              />
                              %
                            </label>
                          </div>
                        </div>
                        <!-- Unit Price -->
                        <div style="max-width: 160px">
                          <label class="fontSize">Unit Price</label>
                          <input
                            type="number"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="unitPrice"
                            placeholder="Unit Price"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              gap: 10px;
                            "
                          >
                            <label>
                              <input
                                type="radio"
                                name="unit"
                                value="$"
                                [(ngModel)]="unitPriceType"
                              />
                              $
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="unit"
                                value="%"
                                [(ngModel)]="unitPriceType"
                              />
                              %
                            </label>
                          </div>
                        </div>
                        <!-- submit button -->
                        <button
                          class="btn btn-sm fontSize"
                          style="
                            font-size: 14px;
                            height: 30px; /* ✅ match input height */
                            padding: 0 12px; /* ✅ adjust padding to center text */
                            border-radius: 4px; /* match input radius */
                            background-color: #142a49;
                            border: 1px solid #142a49;
                            color: #ffffff;
                            cursor: pointer;
                          "
                          (click)="showTable()"
                        >
                          Submit
                        </button>
                      </div>

                      <!-- showing all tables auto -->
                      <!-- Condition 0: -->
                      <ng-container
                        style="margin-top: 8px"
                        *ngIf="showPricingTable && showTableType === 'default'"
                      >
                        <h4 class="pricing-first-heading">Pricing: Default</h4>
                        <h4 class="pricing-first-heading">Pricing: Default</h4>

                        <table
                          style="
                            width: 100%;
                            border-collapse: collapse;
                            font-size: 13px;
                          "
                        >
                          <thead
                            style="background-color: #808285; color: white"
                          >
                            <tr>
                              <th style="padding: 6px; border: 1px solid #ccc">
                                Unit Price
                              </th>
                              <th style="padding: 6px; border: 1px solid #ccc">
                                Advisor Commission %
                              </th>
                              <th style="padding: 6px; border: 1px solid #ccc">
                                TPA Commission $
                              </th>
                              <th style="padding: 6px; border: 1px solid #ccc">
                                Other Fees $
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td style="padding: 6px; border: 1px solid #ccc">
                                <input
                                  type="text"
                                  (keydown)="
                                    allowCurrencyOrPercent(
                                      $event,
                                      $event.target['value']
                                    )
                                  "
                                  (paste)="preventInvalidPaste($event)"
                                  [ngModel]="
                                    getPricingValue(
                                      'default',
                                      '',
                                      '',
                                      '',
                                      '',
                                      'Unit Price'
                                    )
                                  "
                                  (ngModelChange)="
                                    setPricingValue(
                                      'default',
                                      '',
                                      '',
                                      '',
                                      '',
                                      'Unit Price',
                                      $event
                                    )
                                  "
                                  style="
                                    width: 100%;
                                    border: none;
                                    outline: none;
                                    text-align: center;
                                  "
                                />
                              </td>
                              <td style="padding: 6px; border: 1px solid #ccc">
                                <input
                                  type="text"
                                  (keydown)="
                                    allowCurrencyOrPercent(
                                      $event,
                                      $event.target['value']
                                    )
                                  "
                                  (paste)="preventInvalidPaste($event)"
                                  [ngModel]="
                                    getPricingValue(
                                      'default',
                                      '',
                                      '',
                                      '',
                                      '',
                                      'Advisor Commission'
                                    )
                                  "
                                  (ngModelChange)="
                                    setPricingValue(
                                      'default',
                                      '',
                                      '',
                                      '',
                                      '',
                                      'Advisor Commission',
                                      $event
                                    )
                                  "
                                  style="
                                    width: 100%;
                                    border: none;
                                    outline: none;
                                    text-align: center;
                                  "
                                />
                              </td>
                              <td style="padding: 6px; border: 1px solid #ccc">
                                <input
                                  type="text"
                                  (keydown)="
                                    allowCurrencyOrPercent(
                                      $event,
                                      $event.target['value']
                                    )
                                  "
                                  (paste)="preventInvalidPaste($event)"
                                  [ngModel]="
                                    getPricingValue(
                                      'default',
                                      '',
                                      '',
                                      '',
                                      '',
                                      'TPA Commission'
                                    )
                                  "
                                  (ngModelChange)="
                                    setPricingValue(
                                      'default',
                                      '',
                                      '',
                                      '',
                                      '',
                                      'TPA Commission',
                                      $event
                                    )
                                  "
                                  style="
                                    width: 100%;
                                    border: none;
                                    outline: none;
                                    text-align: center;
                                  "
                                />
                              </td>
                              <td style="padding: 6px; border: 1px solid #ccc">
                                <input
                                  type="text"
                                  (keydown)="
                                    allowCurrencyOrPercent(
                                      $event,
                                      $event.target['value']
                                    )
                                  "
                                  (paste)="preventInvalidPaste($event)"
                                  [ngModel]="
                                    getPricingValue(
                                      'default',
                                      '',
                                      '',
                                      '',
                                      '',
                                      'Other Fees'
                                    )
                                  "
                                  (ngModelChange)="
                                    setPricingValue(
                                      'default',
                                      '',
                                      '',
                                      '',
                                      '',
                                      'Other Fees',
                                      $event
                                    )
                                  "
                                  style="
                                    width: 100%;
                                    border: none;
                                    outline: none;
                                    text-align: center;
                                  "
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </ng-container>
                      <!-- pending condition :Zone → Tier → Category -->
                      <ng-container
                        style="
                          width: 100%;
                          display: flex;
                          flex-direction: column;
                          justify-content: center;
                        "
                        *ngIf="
                          showPricingTable &&
                          showTableType === 'zone-tier-category'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Tier → Category
                        </h4>

                        <!-- Loop through Zones -->
                        <div
                          *ngFor="let zone of pricingAreaRows"
                          style="margin-bottom: 20px"
                        >
                          <h5 class="pricing-second-heading">
                            Zone: {{ zone.name }}
                          </h5>

                          <!-- Horizontal tier table wrapper -->
                          <div
                            style="
                              display: flex;
                              flex-wrap: wrap;
                              gap: 20px;
                              padding-left: 10px;
                              padding-right: 10px;
                            "
                          >
                            <div
                              *ngFor="let tier of tieredRows"
                              style="
                                width: 32%;
                                min-width: 300px;
                                background: #fff;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);

                                padding: 10px;
                              "
                            >
                              <h6
                                style="margin-left: 150px"
                                class="pricing-third-heading"
                              >
                                Tier: {{ tier.name }}
                              </h6>
                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 13px;
                                "
                              >
                                <thead
                                  style="
                                    background-color: #808285;
                                    color: white;
                                  "
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Category
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Advisor Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      TPA Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Other Fees
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let category of categoryRows">
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      {{ category.name }}
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            category.name,
                                            'Unit Price'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            category.name,
                                            'Unit Price',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            category.name,
                                            'Advisor Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            category.name,
                                            'Advisor Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            category.name,
                                            'TPA Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            category.name,
                                            'TPA Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            category.name,
                                            'Other Fees'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            category.name,
                                            'Other Fees',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Condition 1: zone-only -->
                      <ng-container
                        style="
                          width: 100%;
                          display: flex;
                          flex-direction: column;
                          justify-content: center;
                          margin-top: 8px;
                        "
                        *ngIf="
                          showPricingTable && showTableType === 'zone-only'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone Only
                        </h4>

                        <!-- Loop through Zones -->
                        <div
                          *ngFor="let zone of pricingAreaRows"
                          style="
                            background: #fff;
                            box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                            padding: 10px;
                            margin-bottom: 20px;
                            width: 100%;
                          "
                        >
                          <h5 class="pricing-second-heading">
                            Zone: {{ zone.name }}
                          </h5>

                          <table
                            style="
                              width: 100%;
                              border-collapse: collapse;
                              font-size: 13px;
                            "
                          >
                            <thead
                              style="background-color: #808285; color: white"
                            >
                              <tr>
                                <th
                                  style="padding: 6px; border: 1px solid #ccc"
                                >
                                  Unit Price
                                </th>
                                <th
                                  style="padding: 6px; border: 1px solid #ccc"
                                >
                                  Advisor Commission
                                </th>
                                <th
                                  style="padding: 6px; border: 1px solid #ccc"
                                >
                                  TPA Commission
                                </th>
                                <th
                                  style="padding: 6px; border: 1px solid #ccc"
                                >
                                  Other Fees
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  style="padding: 6px; border: 1px solid #ccc"
                                >
                                  <input
                                    type="text"
                                    (keydown)="
                                      allowCurrencyOrPercent(
                                        $event,
                                        $event.target['value']
                                      )
                                    "
                                    (paste)="preventInvalidPaste($event)"
                                    [ngModel]="
                                      getPricingValue(
                                        zone.name,
                                        '',
                                        '',
                                        '',
                                        '',
                                        'Unit Price'
                                      )
                                    "
                                    (ngModelChange)="
                                      setPricingValue(
                                        zone.name,
                                        '',
                                        '',
                                        '',
                                        '',
                                        'Unit Price',
                                        $event
                                      )
                                    "
                                    style="
                                      width: 100%;
                                      border: none;
                                      outline: none;
                                      text-align: center;
                                    "
                                  />
                                </td>

                                <td
                                  style="padding: 6px; border: 1px solid #ccc"
                                >
                                  <input
                                    type="text"
                                    (keydown)="
                                      allowCurrencyOrPercent(
                                        $event,
                                        $event.target['value']
                                      )
                                    "
                                    (paste)="preventInvalidPaste($event)"
                                    [ngModel]="
                                      getPricingValue(
                                        zone.name,
                                        '',
                                        '',
                                        '',
                                        '',
                                        'Advisor Commission'
                                      )
                                    "
                                    (ngModelChange)="
                                      setPricingValue(
                                        zone.name,
                                        '',
                                        '',
                                        '',
                                        '',
                                        'Advisor Commission',
                                        $event
                                      )
                                    "
                                    style="
                                      width: 100%;
                                      border: none;
                                      outline: none;
                                      text-align: center;
                                    "
                                  />
                                </td>

                                <td
                                  style="padding: 6px; border: 1px solid #ccc"
                                >
                                  <input
                                    type="text"
                                    (keydown)="
                                      allowCurrencyOrPercent(
                                        $event,
                                        $event.target['value']
                                      )
                                    "
                                    (paste)="preventInvalidPaste($event)"
                                    [ngModel]="
                                      getPricingValue(
                                        zone.name,
                                        '',
                                        '',
                                        '',
                                        '',
                                        'TPA Commission'
                                      )
                                    "
                                    (ngModelChange)="
                                      setPricingValue(
                                        zone.name,
                                        '',
                                        '',
                                        '',
                                        '',
                                        'TPA Commission',
                                        $event
                                      )
                                    "
                                    style="
                                      width: 100%;
                                      border: none;
                                      outline: none;
                                      text-align: center;
                                    "
                                  />
                                </td>

                                <td
                                  style="padding: 6px; border: 1px solid #ccc"
                                >
                                  <input
                                    type="text"
                                    (keydown)="
                                      allowCurrencyOrPercent(
                                        $event,
                                        $event.target['value']
                                      )
                                    "
                                    (paste)="preventInvalidPaste($event)"
                                    [ngModel]="
                                      getPricingValue(
                                        zone.name,
                                        '',
                                        '',
                                        '',
                                        '',
                                        'Other Fees'
                                      )
                                    "
                                    (ngModelChange)="
                                      setPricingValue(
                                        zone.name,
                                        '',
                                        '',
                                        '',
                                        '',
                                        'Other Fees',
                                        $event
                                      )
                                    "
                                    style="
                                      width: 100%;
                                      border: none;
                                      outline: none;
                                      text-align: center;
                                    "
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </ng-container>

                      <!-- Condition 2: Zone + Tier -->
                      <div
                        *ngIf="
                          showPricingTable && showTableType === 'zone-tier'
                        "
                        style="
                          width: 100%;
                          display: flex;
                          flex-direction: column;
                          justify-content: center;
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Tier
                        </h4>

                        <!-- Wrapper for all zones -->
                        <div style="display: flex; flex-wrap: wrap; gap: 20px">
                          <div
                            *ngFor="let zone of pricingAreaRows"
                            style="
                              flex: 1 1 calc(33.333% - 20px);
                              box-sizing: border-box;
                            "
                          >
                            <div
                              style="
                                background: #fff;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                                padding: 10px;
                                margin-top: 10px;
                                width: 100%;
                              "
                            >
                              <!-- Zone heading moved inside white box -->
                              <h5
                                style="
                                  width: fit-content;
                                  background-color: #142a49;
                                  color: white;
                                  width: fit-content;
                                  background-color: #142a49;
                                  color: white;
                                  font-weight: 500;
                                  font-size: 14px;
                                  border-radius: 2px;
                                  padding: 5px 6px;
                                "
                              >
                                Zone: {{ zone.name }}
                              </h5>

                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 13px;
                                "
                              >
                                <thead
                                  style="
                                    background-color: #808285;
                                    color: white;
                                  "
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Tier
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Advisor Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      TPA Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Other Fees
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let tier of tieredRows">
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      {{ tier.name }}
                                    </td>
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            '',
                                            'Unit Price'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            '',
                                            'Unit Price',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            '',
                                            'Advisor Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            '',
                                            'Advisor Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            '',
                                            'TPA Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            '',
                                            'TPA Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            '',
                                            'Other Fees'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            '',
                                            '',
                                            'Other Fees',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Condition 6: Zone + Tier + Variant + Category -->
                      <ng-container
                        style="margin-top: 8px"
                        *ngIf="
                          showPricingTable &&
                          showTableType === 'zone-tier-variant-category'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Tier → Variant → Category
                        </h4>

                        <div
                          *ngFor="let zone of pricingAreaRows"
                          style="margin-bottom: 30px"
                        >
                          <h5 class="pricing-second-heading">
                            Zone: {{ zone.name }}
                          </h5>

                          <div
                            *ngFor="let tier of tieredRows"
                            style="margin-left: 15px; margin-bottom: 20px"
                          >
                            <h6 class="pricing-third-heading">
                              Tier: {{ tier.name }}
                            </h6>

                            <!-- Variant Grid -->
                            <div
                              style="
                                display: flex;
                                flex-wrap: wrap;
                                gap: 20px;
                                margin-left: 15px;
                              "
                            >
                              <div
                                *ngFor="let variant of variantRows"
                                style="
                                  flex: 1 1 calc(33.333% - 20px);
                                  background: #fff;
                                  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                                  padding: 10px;
                                  box-sizing: border-box;
                                "
                              >
                                <h6
                                  style="
                                    width: fit-content;
                                    background-color: #142a49;
                                    color: white;
                                    width: fit-content;
                                    background-color: #142a49;
                                    color: white;
                                    font-weight: 500;
                                    font-size: 14px;
                                    border-radius: 2px;
                                    padding: 5px 6px;
                                  "
                                >
                                  Variant: {{ variant.name }}
                                </h6>

                                <table
                                  style="
                                    width: 100%;
                                    border-collapse: collapse;
                                    font-size: 13px;
                                  "
                                >
                                  <thead
                                    style="
                                      background-color: #808285;
                                      color: white;
                                    "
                                  >
                                    <tr>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        Category
                                      </th>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        Unit Price
                                      </th>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        Advisor Commission
                                      </th>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        TPA Commission
                                      </th>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        Other Fees
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let category of categoryRows">
                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        {{ category.name }}
                                      </td>
                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        <input
                                          type="text"
                                          (keydown)="
                                            allowCurrencyOrPercent(
                                              $event,
                                              $event.target['value']
                                            )
                                          "
                                          (paste)="preventInvalidPaste($event)"
                                          [ngModel]="
                                            getPricingValue(
                                              zone.name,
                                              tier.name,
                                              '',
                                              variant.name,
                                              category.name,
                                              'Unit Price'
                                            )
                                          "
                                          (ngModelChange)="
                                            setPricingValue(
                                              zone.name,
                                              tier.name,
                                              '',
                                              variant.name,
                                              category.name,
                                              'Unit Price',
                                              $event
                                            )
                                          "
                                          style="
                                            width: 100%;
                                            border: none;
                                            outline: none;
                                            text-align: center;
                                          "
                                        />
                                      </td>
                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        <input
                                          type="text"
                                          (keydown)="
                                            allowCurrencyOrPercent(
                                              $event,
                                              $event.target['value']
                                            )
                                          "
                                          (paste)="preventInvalidPaste($event)"
                                          [ngModel]="
                                            getPricingValue(
                                              zone.name,
                                              tier.name,
                                              '',
                                              variant.name,
                                              category.name,
                                              'Advisor Commission'
                                            )
                                          "
                                          (ngModelChange)="
                                            setPricingValue(
                                              zone.name,
                                              tier.name,
                                              '',
                                              variant.name,
                                              category.name,
                                              'Advisor Commission',
                                              $event
                                            )
                                          "
                                          style="
                                            width: 100%;
                                            border: none;
                                            outline: none;
                                            text-align: center;
                                          "
                                        />
                                      </td>
                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        <input
                                          type="text"
                                          (keydown)="
                                            allowCurrencyOrPercent(
                                              $event,
                                              $event.target['value']
                                            )
                                          "
                                          (paste)="preventInvalidPaste($event)"
                                          [ngModel]="
                                            getPricingValue(
                                              zone.name,
                                              tier.name,
                                              '',
                                              variant.name,
                                              category.name,
                                              'TPA Commission'
                                            )
                                          "
                                          (ngModelChange)="
                                            setPricingValue(
                                              zone.name,
                                              tier.name,
                                              '',
                                              variant.name,
                                              category.name,
                                              'TPA Commission',
                                              $event
                                            )
                                          "
                                          style="
                                            width: 100%;
                                            border: none;
                                            outline: none;
                                            text-align: center;
                                          "
                                        />
                                      </td>
                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        <input
                                          type="text"
                                          (keydown)="
                                            allowCurrencyOrPercent(
                                              $event,
                                              $event.target['value']
                                            )
                                          "
                                          (paste)="preventInvalidPaste($event)"
                                          [ngModel]="
                                            getPricingValue(
                                              zone.name,
                                              tier.name,
                                              '',
                                              variant.name,
                                              category.name,
                                              'Other Fees'
                                            )
                                          "
                                          (ngModelChange)="
                                            setPricingValue(
                                              zone.name,
                                              tier.name,
                                              '',
                                              variant.name,
                                              category.name,
                                              'Other Fees',
                                              $event
                                            )
                                          "
                                          style="
                                            width: 100%;
                                            border: none;
                                            outline: none;
                                            text-align: center;
                                          "
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Condition 7: Zone + Age Band + Variant + Category (3 per row) -->
                      <ng-container
                        style="margin-top: 8px"
                        *ngIf="
                          showPricingTable &&
                          showTableType === 'zone-age-variant-category'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Age Band → Variant → Category
                        </h4>

                        <div
                          *ngFor="let zone of pricingAreaRows"
                          style="margin-bottom: 30px"
                        >
                          <h5 class="pricing-second-heading">
                            Zone: {{ zone.name }}
                          </h5>

                          <div
                            *ngFor="let age of ageBands"
                            style="margin-left: 15px; margin-bottom: 20px"
                          >
                            <h6 class="pricing-third-heading">
                              Age Band: {{ age.start }} - {{ age.end }}
                            </h6>

                            <!-- 3 variants per row inside white cards -->
                            <div
                              style="
                                display: flex;
                                flex-wrap: wrap;
                                gap: 20px;
                                margin-left: 15px;
                              "
                            >
                              <div
                                *ngFor="let variant of variantRows"
                                style="
                                  flex: 1 1 calc(33.333% - 20px);
                                  box-sizing: border-box;
                                  background: white;
                                  padding: 16px;
                                  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                                  border-radius: 8px;
                                "
                              >
                                <h6
                                  style="
                                    width: fit-content;
                                    background-color: #142a49;
                                    color: white;
                                    width: fit-content;
                                    background-color: #142a49;
                                    color: white;
                                    font-weight: 500;
                                    font-size: 14px;
                                    border-radius: 2px;
                                    padding: 5px 6px;
                                  "
                                >
                                  Variant:<strong> {{ variant.name }}</strong>
                                </h6>

                                <table
                                  style="
                                    width: 100%;
                                    border-collapse: collapse;
                                    font-size: 13px;
                                  "
                                >
                                  <thead
                                    style="
                                      background-color: #808285;
                                      color: white;
                                    "
                                  >
                                    <tr>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        Category
                                      </th>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        Unit Price
                                      </th>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        Advisor Commission
                                      </th>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        TPA Commission
                                      </th>
                                      <th
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        Other Fees
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr *ngFor="let category of categoryRows">
                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        {{ category.name }}
                                      </td>

                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        <input
                                          type="text"
                                          (keydown)="
                                            allowCurrencyOrPercent(
                                              $event,
                                              $event.target['value']
                                            )
                                          "
                                          (paste)="preventInvalidPaste($event)"
                                          [ngModel]="
                                            getPricingValue(
                                              zone.name,
                                              '',
                                              age.start + '-' + age.end,
                                              variant.name,
                                              category.name,
                                              'Unit Price'
                                            )
                                          "
                                          (ngModelChange)="
                                            setPricingValue(
                                              zone.name,
                                              '',
                                              age.start + '-' + age.end,
                                              variant.name,
                                              category.name,
                                              'Unit Price',
                                              $event
                                            )
                                          "
                                          style="
                                            width: 100%;
                                            border: none;
                                            outline: none;
                                            text-align: center;
                                          "
                                        />
                                      </td>

                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        <input
                                          type="text"
                                          (keydown)="
                                            allowCurrencyOrPercent(
                                              $event,
                                              $event.target['value']
                                            )
                                          "
                                          (paste)="preventInvalidPaste($event)"
                                          [ngModel]="
                                            getPricingValue(
                                              zone.name,
                                              '',
                                              age.start + '-' + age.end,
                                              variant.name,
                                              category.name,
                                              'Advisor Commission'
                                            )
                                          "
                                          (ngModelChange)="
                                            setPricingValue(
                                              zone.name,
                                              '',
                                              age.start + '-' + age.end,
                                              variant.name,
                                              category.name,
                                              'Advisor Commission',
                                              $event
                                            )
                                          "
                                          style="
                                            width: 100%;
                                            border: none;
                                            outline: none;
                                            text-align: center;
                                          "
                                        />
                                      </td>

                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        <input
                                          type="text"
                                          (keydown)="
                                            allowCurrencyOrPercent(
                                              $event,
                                              $event.target['value']
                                            )
                                          "
                                          (paste)="preventInvalidPaste($event)"
                                          [ngModel]="
                                            getPricingValue(
                                              zone.name,
                                              '',
                                              age.start + '-' + age.end,
                                              variant.name,
                                              category.name,
                                              'TPA Commission'
                                            )
                                          "
                                          (ngModelChange)="
                                            setPricingValue(
                                              zone.name,
                                              '',
                                              age.start + '-' + age.end,
                                              variant.name,
                                              category.name,
                                              'TPA Commission',
                                              $event
                                            )
                                          "
                                          style="
                                            width: 100%;
                                            border: none;
                                            outline: none;
                                            text-align: center;
                                          "
                                        />
                                      </td>

                                      <td
                                        style="
                                          padding: 6px;
                                          border: 1px solid #ccc;
                                        "
                                      >
                                        <input
                                          type="text"
                                          (keydown)="
                                            allowCurrencyOrPercent(
                                              $event,
                                              $event.target['value']
                                            )
                                          "
                                          (paste)="preventInvalidPaste($event)"
                                          [ngModel]="
                                            getPricingValue(
                                              zone.name,
                                              '',
                                              age.start + '-' + age.end,
                                              variant.name,
                                              category.name,
                                              'Other Fees'
                                            )
                                          "
                                          (ngModelChange)="
                                            setPricingValue(
                                              zone.name,
                                              '',
                                              age.start + '-' + age.end,
                                              variant.name,
                                              category.name,
                                              'Other Fees',
                                              $event
                                            )
                                          "
                                          style="
                                            width: 100%;
                                            border: none;
                                            outline: none;
                                            text-align: center;
                                          "
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Condition 10: Zone → Age Band → Variant -->
                      <ng-container
                        style="
                          margin-top: 8px;
                          width: 100%;
                          display: flex;
                          flex-direction: column;
                        "
                        *ngIf="
                          showPricingTable &&
                          showTableType === 'zone-age-variant'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Age Band → Variant
                        </h4>

                        <!-- Loop through Zones -->
                        <div
                          *ngFor="let zone of pricingAreaRows"
                          style="margin-bottom: 30px"
                        >
                          <h5 class="pricing-second-heading">
                            Zone: {{ zone.name }}
                          </h5>

                          <!-- Horizontal age-band card layout like tier cards -->
                          <div
                            style="
                              display: flex;
                              flex-wrap: wrap;
                              gap: 20px;
                              padding-left: 10px;
                              padding-right: 10px;
                            "
                          >
                            <!-- Age Band Card -->
                            <div
                              *ngFor="let age of ageBands"
                              style="
                                width: 32%;
                                min-width: 300px;
                                background: #fff;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                                padding: 12px;
                              "
                            >
                              <h6
                                class="pricing-third-heading"
                                style="text-align: center"
                              >
                                Age Band: {{ age.start }} - {{ age.end }}
                              </h6>

                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 13px;
                                "
                              >
                                <thead
                                  style="
                                    background-color: #808285;
                                    color: white;
                                  "
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Variant
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Advisor Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      TPA Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Other Fees
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let variant of variantRows">
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      {{ variant.name }}
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            variant.name,
                                            '',
                                            'Unit Price'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            variant.name,
                                            '',
                                            'Unit Price',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            variant.name,
                                            '',
                                            'Advisor Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            variant.name,
                                            '',
                                            'Advisor Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            variant.name,
                                            '',
                                            'TPA Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            variant.name,
                                            '',
                                            'TPA Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            variant.name,
                                            '',
                                            'Other Fees'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            variant.name,
                                            '',
                                            'Other Fees',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Condition 11: Zone + Age Band + Category -->
                      <ng-container
                        style="margin-top: 8px"
                        *ngIf="
                          showPricingTable &&
                          showTableType === 'zone-age-category'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Age Band → Category
                        </h4>

                        <!-- Loop through Zones -->
                        <div
                          *ngFor="let zone of pricingAreaRows"
                          style="margin-bottom: 30px"
                        >
                          <h5 class="pricing-second-heading">
                            Zone: {{ zone.name }}
                          </h5>

                          <!-- Horizontal age band layout like tier cards -->
                          <div
                            style="
                              display: flex;
                              flex-wrap: wrap;
                              gap: 20px;
                              padding-left: 10px;
                              padding-right: 10px;
                            "
                          >
                            <!-- Age Band Card -->
                            <div
                              *ngFor="let age of ageBands"
                              style="
                                width: 32%;
                                min-width: 300px;
                                background: #fff;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                                padding: 12px;
                              "
                            >
                              <h6
                                class="pricing-third-heading"
                                style="text-align: center"
                              >
                                Age Band: {{ age.start }} - {{ age.end }}
                              </h6>

                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 13px;
                                "
                              >
                                <thead
                                  style="
                                    background-color: #808285;
                                    color: white;
                                  "
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Category
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Advisor Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      TPA Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Other Fees
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let category of categoryRows">
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      {{ category.name }}
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            category.name,
                                            'Unit Price'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            category.name,
                                            'Unit Price',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            category.name,
                                            'Advisor Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            category.name,
                                            'Advisor Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            category.name,
                                            'TPA Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            category.name,
                                            'TPA Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            category.name,
                                            'Other Fees'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            category.name,
                                            'Other Fees',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Condition 12: Zone + Tier + Variant -->
                      <ng-container
                        style="margin-top: 8px"
                        *ngIf="
                          showPricingTable &&
                          showTableType === 'zone-tier-variant'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Tier → Variant
                        </h4>

                        <!-- Loop through Zones -->
                        <div
                          *ngFor="let zone of pricingAreaRows"
                          style="margin-bottom: 30px"
                        >
                          <h5 class="pricing-second-heading">
                            Zone: {{ zone.name }}
                          </h5>

                          <!-- Horizontal tier layout like cards -->
                          <div
                            style="
                              display: flex;
                              flex-wrap: wrap;
                              gap: 20px;
                              padding-left: 10px;
                              padding-right: 10px;
                            "
                          >
                            <!-- Tier Card -->
                            <div
                              *ngFor="let tier of tieredRows"
                              style="
                                width: 32%;
                                min-width: 300px;
                                background: #fff;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                                padding: 12px;
                              "
                            >
                              <h6
                                class="pricing-third-heading"
                                style="text-align: center"
                              >
                                Tier: {{ tier.name }}
                              </h6>

                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 13px;
                                "
                              >
                                <thead
                                  style="
                                    background-color: #808285;
                                    color: white;
                                  "
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Variant
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Advisor Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      TPA Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Other Fees
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let variant of variantRows">
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      {{ variant.name }}
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            variant.name,
                                            '',
                                            'Unit Price'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            variant.name,
                                            '',
                                            'Unit Price',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            variant.name,
                                            '',
                                            'Advisor Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            variant.name,
                                            '',
                                            'Advisor Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            variant.name,
                                            '',
                                            'TPA Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            variant.name,
                                            '',
                                            'TPA Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            variant.name,
                                            '',
                                            'Other Fees'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            tier.name,
                                            '',
                                            variant.name,
                                            '',
                                            'Other Fees',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Condition 15: Zone + Variant + Category (Card Layout) -->
                      <ng-container
                        style="margin-top: 8px"
                        *ngIf="
                          showPricingTable &&
                          showTableType === 'zone-variant-category'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Variant → Category
                        </h4>

                        <!-- Loop through Zones -->
                        <div
                          *ngFor="let zone of pricingAreaRows"
                          style="margin-bottom: 30px"
                        >
                          <h5 class="pricing-second-heading">
                            Zone: {{ zone.name }}
                          </h5>

                          <!-- Variant Cards Row -->
                          <div
                            style="
                              display: flex;
                              flex-wrap: wrap;
                              gap: 20px;
                              padding-left: 10px;
                              padding-right: 10px;
                            "
                          >
                            <!-- Variant Card -->
                            <div
                              *ngFor="let variant of variantRows"
                              style="
                                width: 32%;
                                min-width: 300px;
                                background: #fff;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
                                padding: 12px;
                              "
                            >
                              <h6
                                style="text-align: center; margin-bottom: 10px"
                              >
                                Variant: {{ variant.name }}
                              </h6>

                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 13px;
                                "
                              >
                                <thead
                                  style="
                                    background-color: #808285;
                                    color: white;
                                  "
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Category
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Advisor Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      TPA Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Other Fees
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let category of categoryRows">
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      {{ category.name }}
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            category.name,
                                            'Unit Price'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            category.name,
                                            'Unit Price',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            category.name,
                                            'Advisor Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            category.name,
                                            'Advisor Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            category.name,
                                            'TPA Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            category.name,
                                            'TPA Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            category.name,
                                            'Other Fees'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            category.name,
                                            'Other Fees',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Condition 20: Zone + Variant (right) -->
                      <!-- Condition 20: Zone + Variant (right) -->
                      <ng-container
                        style="margin-top: 8px"
                        *ngIf="
                          showPricingTable && showTableType === 'zone-variant'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Variant
                        </h4>

                        <!-- Chunked rows of 3 zones -->
                        <div
                          style="
                            display: flex;
                            flex-wrap: wrap;
                            gap: 20px;
                            margin-top: 16px;
                          "
                        >
                          <div
                            *ngFor="let zone of pricingAreaRows"
                            style="
                              flex: 1 1 calc(33.333% - 20px);
                              box-sizing: border-box;
                            "
                          >
                            <!-- White card for each zone -->
                            <div
                              style="
                                background: white;
                                padding: 16px;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                                border-radius: 8px;
                                margin-bottom: 30px;
                              "
                            >
                              <h5
                                style="
                                  width: fit-content;
                                  background-color: #142a49;
                                  color: white;
                                  width: fit-content;
                                  background-color: #142a49;
                                  color: white;
                                  font-weight: 500;
                                  font-size: 14px;
                                  border-radius: 2px;
                                  padding: 5px 6px;
                                "
                              >
                                Zone: {{ zone.name }}
                              </h5>

                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 13px;
                                "
                              >
                                <thead
                                  style="
                                    background-color: #808285;
                                    color: white;
                                  "
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Variant
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Advisor Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      TPA Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Other Fees
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let variant of variantRows">
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      {{ variant.name }}
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            '',
                                            'Unit Price'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            '',
                                            'Unit Price',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            '',
                                            'Advisor Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            '',
                                            'Advisor Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            '',
                                            'TPA Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            '',
                                            'TPA Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            '',
                                            'Other Fees'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            variant.name,
                                            '',
                                            'Other Fees',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Condition 21: Zone + Category (right) -->
                      <!-- Condition 21: Zone + Category (right) -->
                      <ng-container
                        style="margin-top: 8px"
                        *ngIf="
                          showPricingTable && showTableType === 'zone-category'
                        "
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Category
                        </h4>

                        <!-- Wrapper to make 3 zone tables per row -->
                        <div
                          style="
                            display: flex;
                            flex-wrap: wrap;
                            gap: 20px;
                            margin-top: 16px;
                          "
                        >
                          <div
                            *ngFor="let zone of pricingAreaRows"
                            style="
                              flex: 1 1 calc(33.333% - 20px);
                              box-sizing: border-box;
                            "
                          >
                            <!-- White card -->
                            <div
                              style="
                                background: white;
                                padding: 16px;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                                border-radius: 8px;
                                margin-bottom: 30px;
                              "
                            >
                              <h5
                                style="
                                  width: fit-content;
                                  background-color: #142a49;
                                  color: white;
                                  width: fit-content;
                                  background-color: #142a49;
                                  color: white;
                                  font-weight: 500;
                                  font-size: 14px;
                                  border-radius: 2px;
                                  padding: 5px 6px;
                                "
                              >
                                Zone: {{ zone.name }}
                              </h5>

                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 13px;
                                "
                              >
                                <thead
                                  style="
                                    background-color: #808285;
                                    color: white;
                                  "
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Category
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Advisor Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      TPA Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Other Fees
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let category of categoryRows">
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      {{ category.name }}
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            '',
                                            category.name,
                                            'Unit Price'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            '',
                                            category.name,
                                            'Unit Price',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            '',
                                            category.name,
                                            'Advisor Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            '',
                                            category.name,
                                            'Advisor Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            '',
                                            category.name,
                                            'TPA Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            '',
                                            category.name,
                                            'TPA Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            '',
                                            category.name,
                                            'Other Fees'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            '',
                                            '',
                                            category.name,
                                            'Other Fees',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Condition 23: Zone → Age (right) -->
                      <ng-container
                        style="margin-top: 8px"
                        *ngIf="showPricingTable && showTableType === 'zone-age'"
                      >
                        <h4 class="pricing-first-heading">
                          Pricing: Zone → Age Band
                        </h4>

                        <!-- Wrapper for flex layout: 3 zones per row -->
                        <div
                          style="
                            display: flex;
                            flex-wrap: wrap;
                            gap: 20px;
                            margin-top: 16px;
                          "
                        >
                          <div
                            *ngFor="let zone of pricingAreaRows"
                            style="
                              flex: 1 1 calc(33.333% - 20px);
                              box-sizing: border-box;
                            "
                          >
                            <!-- White box with shadow -->
                            <div
                              style="
                                background: white;
                                padding: 16px;
                                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
                                border-radius: 8px;
                                margin-bottom: 30px;
                              "
                            >
                              <h6
                                style="
                                  width: fit-content;
                                  background-color: #142a49;
                                  color: white;
                                  width: fit-content;
                                  background-color: #142a49;
                                  color: white;
                                  font-weight: 500;
                                  font-size: 14px;
                                  border-radius: 2px;
                                  padding: 5px 6px;
                                "
                              >
                                Zone: {{ zone.name }}
                              </h6>

                              <table
                                style="
                                  width: 100%;
                                  border-collapse: collapse;
                                  font-size: 13px;
                                "
                              >
                                <thead
                                  style="
                                    background-color: #808285;
                                    color: white;
                                  "
                                >
                                  <tr>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Age Band
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Unit Price
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Advisor Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      TPA Commission
                                    </th>
                                    <th
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      Other Fees
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let age of ageBands">
                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      {{ age.start }} - {{ age.end }}
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            '',
                                            'Unit Price'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            '',
                                            'Unit Price',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            '',
                                            'Advisor Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            '',
                                            'Advisor Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            '',
                                            'TPA Commission'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            '',
                                            'TPA Commission',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>

                                    <td
                                      style="
                                        padding: 6px;
                                        border: 1px solid #ccc;
                                      "
                                    >
                                      <input
                                        type="text"
                                        (keydown)="
                                          allowCurrencyOrPercent(
                                            $event,
                                            $event.target['value']
                                          )
                                        "
                                        (paste)="preventInvalidPaste($event)"
                                        [ngModel]="
                                          getPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            '',
                                            'Other Fees'
                                          )
                                        "
                                        (ngModelChange)="
                                          setPricingValue(
                                            zone.name,
                                            '',
                                            age.start + '-' + age.end,
                                            '',
                                            '',
                                            'Other Fees',
                                            $event
                                          )
                                        "
                                        style="
                                          width: 100%;
                                          border: none;
                                          outline: none;
                                          text-align: center;
                                        "
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>

                    <!-- Save product button -->
                    <!-- *ngIf="
                      isProductValidForFirstRow &&
                      isProductValidForSecondRow &&
                      isProductValidForThirdRow &&
                      isProductValidForVendorAndPricing &&
                      isPricingSection &&
                      showPricingTable
                    " -->
                    <div
                      style="
                        width: 100%;
                        position: sticky;
                        bottom: 0;
                        background-color: white;
                        z-index: 10;
                        padding: 10px 20px;
                        display: flex;
                        justify-content: flex-end;
                        gap: 10px;
                      "
                    >
                      <!-- Log data button -->
                      <!-- <button
                        class="fontSize"
                        style="
                          background-color: #142a49;
                          color: white;
                          border: 2px solid #fff;
                          border-radius: 8px;
                          padding: 5px 18px;
                          font-family: Arial, sans-serif;
                          cursor: pointer;
                        "
                        (click)="LogAllData()"
                      >
                        Log All Data
                      </button> -->

                      <!-- Cancel -->
                      <button
                        class="btn btn-sm fontSize"
                        style="
                          font-size: 14px;
                          padding: 4px 12px;
                          border-radius: 4px;
                          background-color: white;
                          border: 1px solid #142a49;
                          color: #142a49;
                          cursor: pointer;
                        "
                        (click)="showProductModal = false"
                      >
                        Cancel
                      </button>
                      <!--Save Product Button  -->
                      <!-- *ngIf="
                        isProductValidForFirstRow &&
                        isProductValidForSecondRow &&
                        isProductValidForThirdRow &&
                        isProductValidForVendorAndPricing &&
                        isPricingSection &&
                        showPricingTable
                      " -->
                      <button
                        *ngIf="isProductValidForFirstRow && !ageError"
                        class="btn btn-sm fontSize"
                        style="
                          font-size: 14px;
                          padding: 4px 12px;
                          border-radius: 4px;
                          background-color: #142a49;
                          color: white;
                          cursor: pointer;
                          border: 1px solid #142a49;
                        "
                        (click)="onSaveProduct()"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- it is table for showing all added products -->
          <div
            style="
              border: 1px solid #b9b9b9;
              max-height: 130px;
              overflow-y: auto;
            "
          >
            <table
              style="
                width: 100%;
                border-collapse: collapse;
                font-family: Arial, sans-serif;
                font-size: 12px;
              "
            >
              <thead>
                <tr
                  style="background-color: #808285; color: white; height: 29px"
                >
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 20%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    {{ lang.Product_ID }}
                  </th>
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 30%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    {{ lang.Product_Name }}
                  </th>
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 30%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    {{ lang.Distribution_Date }}
                  </th>
                  <th
                    style="
                      text-align: left;
                      padding: 2px 8px;
                      width: 20%;
                      position: sticky;
                      top: 0;
                      background-color: #808285;
                      z-index: 1;
                    "
                  >
                    {{ lang.Actions }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <!-- Product rows -->
                <tr
                  *ngFor="let product of products; let i = index"
                  style="
                    background-color: #f6f6f6;
                    height: 29px;
                    font-size: 14px;
                  "
                >
                  <td style="text-align: left; padding: 2px 8px">
                    {{ product.productInfo.productId }}
                  </td>
                  <td style="text-align: left; padding: 2px 8px">
                    {{ product.productInfo.productName }}
                  </td>
                  <td style="text-align: left; padding: 2px 8px">
                    {{ product.productInfo.effectiveDistributionDate }}
                  </td>
                  <td style="text-align: left; padding: 2px 8px">
                    <button
                      (click)="editProduct(product)"
                      style="
                        background-color: #c87b00;
                        border: none;
                        border-radius: 6px;
                        cursor: pointer;
                        margin-right: 5px;
                        color: white;
                        padding: 2px 8px;
                        font-size: 12px;
                      "
                    >
                      <i class="bi bi-pencil-fill"></i>
                    </button>
                    <button
                      (click)="deleteProduct(product.productInfo.productId)"
                      style="
                        background-color: #6b1004;
                        border: none;
                        border-radius: 6px;
                        cursor: pointer;
                        color: white;
                        padding: 2px 8px;
                        font-size: 12px;
                      "
                    >
                      <i class="bi bi-trash-fill"></i>
                    </button>
                  </td>
                </tr>

                <!-- No data fallback -->
                <tr
                  *ngIf="products.length === 0"
                  style="height: 29px; background-color: #f6f6f6"
                >
                  <td colspan="4" style="padding: 4px 8px; color: #333">
                    No Data available!
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- Created Supplier Popup -->
      <div
        *ngIf="showSupplierBackendResponse"
        class="popup-wrapper"
        style="
          position: fixed;
          top: 0;
          left: 0;
          z-index: 1000;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.4);
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <div
          class="popup-content"
          style="
            background: white;
            width: 300px;
            padding: 20px;
            text-align: center;
            border-radius: 8px;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
          "
        >
          <p style="font-size: 16px; font-weight: 500; color: #2e7d32">
            Supplier
            {{ mode === "update" ? "Updated" : "Created" }} successfully.
          </p>
          <button
            (click)="closeComponent()"
            style="
              margin-top: 12px;
              background-color: #0c2d48;
              color: white;
              border: none;
              padding: 4px 16px;
              border-radius: 4px;
              cursor: pointer;
            "
          >
            OK
          </button>
        </div>
      </div>
      <!-- Save and Next Button -->
      <div
        style="
          position: sticky;
          bottom: 0;
          background: white;
          padding: 10px;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          border-top: 1px solid #ccc;
          z-index: 99;
          margin-top: -5px;
        "
      >
        <!-- Cancel Button -->
        <button
          class="btn btn-sm fontSize"
          style="
            font-size: 14px;
            padding: 4px 12px;
            border-radius: 4px;
            background-color: #fff;
            border: 1px solid #ccc;
            color: #142a49;
            cursor: pointer;
          "
          (click)="closeComponent()"
        >
          Cancel
        </button>

        <!-- Save & Next Button -->
        <!-- *ngIf="
          products.length > 0 &&
          contacts.length > 0 &&
          supplierName?.length > 3 &&
          !matchedSupplierName
        " -->
        <button
          *ngIf="!matchedSupplierName && supplierName?.length > 0"
          class="btn btn-sm fontSize"
          [ngStyle]="{
            fontSize: '14px',
            padding: '4px 12px',
            borderRadius: '4px',
            backgroundColor: '#142a49',
            border: '1px solid #142a49',
            color: '#ffffff'
          }"
          (click)="onSubmitSupplier()"
        >
          {{ mode === "update" ? "Update " : "Save & Next" }}
        </button>
      </div>
      <div style="height: 100px"></div>
    </div>
  </div>
</main>

<!-- Update Product -->
<app-edit-supplier-product
  *ngIf="editSingleProductModal"
  [productData]="selectedProduct"
  [selectedSupplierId]="selectedSupplierId"
  (productUpdated)="onProductUpdated($event)"
  [refreshParentData]="refreshParentData"
  [productModalMode]="productModalMode"
  [editOrUpdate]="'Edit Section'"
  (onClose)="editSingleProductModal = false"
  (onSave)="handleUpdate($event)"
>
</app-edit-supplier-product>
